import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es.array.flat.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { __rest } from 'tslib';
import React, { Fragment, useState, useEffect, createContext, useContext, Component, useMemo, useReducer, useCallback, forwardRef, Children } from 'react';
import { Tabs, TabList, Tab, TabPanel, BlockContainer, ExternalLink, ThemeProvider as ThemeProvider$1, GithubAvatar, Table, Popover, Value, GithubAvatarList, Tag, Link as Link$1, ActionContainer, Tree, getTreeItemsStats, expandTreeItems, Source, Shield, useTheme as useTheme$1, Subtitle as Subtitle$1, Description as Description$1, getAccentPaletteColor, getPaletteColor, Markdown, Pagination as Pagination$1, IconButton, PanelContainer, Zoom, SearchInput, Donut } from '@component-controls/components';
import { CURRENT_STORY as CURRENT_STORY$1, getComponentName, getControlsCount, deepMerge, dateToLocalString, defaultExport, formatStoryPath, getStoryPath, isLocalImport, getDocTypePath, getDocPath, defDocType, getControlValue, getControlValues, canRandomizeControl, canResetControl, randomizeData, resetControlValues, visibleControls, getDefaultStore, defaultBuildConfig, defaultRunConfig, ControlTypes } from '@component-controls/core';
import { useComponents, useStory, useTheme, StateRoot, useStore, useConfig, usePackage, useStoryComponent, useComponent, StoryContextProvider, useDocument, useDocPackage, useCurrentDocument, useDocPropCount, useNavigationInfo, useStoryIdFromName, useCurrentStory, useControl, ControlsContextStoryProvider, useSearch, useExternalOptions } from '@component-controls/store';
import { jsx, Box, Link, Flex, Text, Themed, Image, Heading, Button } from 'theme-ui';
import queryString from 'query-string';
import { GitCommitIcon, TriangleDownIcon, UploadIcon, TriangleRightIcon, MarkGithubIcon, SyncIcon, DashIcon, PlusIcon } from '@primer/octicons-react';
import { mix } from 'polished';
import AnsiUp from 'ansi_up';
import stringifyObject from 'stringify-object';
import { window as window$1 } from 'global';
import jsStringEscape from 'js-string-escape';
import copy from 'copy-to-clipboard';
import { getPropertyEditor } from '@component-controls/editors';
import Iframe from 'react-frame-component';
import ReactResizeDetector from 'react-resize-detector';
import { render } from '@component-controls/render/react';
import ClassicPage from '@component-controls/pages/ClassicPage';

var ComponentsContainer = function ComponentsContainer(_a) {
  var components = _a.components,
      children = _a.children,
      onSelect = _a.onSelect,
      rest = __rest(_a, ["components", "children", "onSelect"]);

  var keys = components ? Object.keys(components) : [];

  if (keys.length === 0) {
    keys.push('Controls');
  }

  if (keys.length <= 1) {
    return React.createElement(Fragment, null, children(components[keys[0]], rest));
  }

  return React.createElement(Tabs, {
    onSelect: onSelect ? function (index) {
      return onSelect(keys[index], components[keys[index]]);
    } : undefined
  }, React.createElement(TabList, null, keys.map(function (key) {
    return React.createElement(Tab, {
      key: "component_tab_".concat(key)
    }, key);
  })), keys.map(function (key) {
    return React.createElement(TabPanel, {
      key: "component_panel_".concat(key)
    }, children(components[key], rest));
  }));
};

var ComponentsBlockContainer = function ComponentsBlockContainer(_a) {
  var userTitle = _a.title,
      collapsible = _a.collapsible,
      name = _a.name,
      id = _a.id,
      of = _a.of,
      children = _a.children,
      visibility = _a.visibility,
      dataTestid = _a['data-testid'],
      rest = __rest(_a, ["title", "collapsible", "name", "id", "of", "children", "visibility", 'data-testid']);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      title = _useState2[0],
      setTitle = _useState2[1];

  var components = useComponents({
    of: of
  });
  var story = useStory({
    id: id,
    name: name
  });
  useEffect(function () {
    var componentNames = Object.keys(components);
    setTitle(userTitle === CURRENT_STORY$1 && componentNames.length ? getComponentName(components[componentNames[0]]) : userTitle);
  }, [userTitle, components]);
  var keys = components && visibility !== 'controls' ? Object.keys(components) : [];

  if (keys.length === 0 && visibility !== 'info' && getControlsCount(story === null || story === void 0 ? void 0 : story.controls) > 0) {
    keys.push('Controls');
  }

  if (keys.length === 0) {
    return null;
  }

  var child = null;
  var block = React.createElement(ComponentsContainer, Object.assign({
    components: components,
    onSelect: function onSelect(tabName) {
      return userTitle === CURRENT_STORY$1 ? setTitle(tabName) : undefined;
    }
  }, rest), function (component, otherProps) {
    child = children(component, otherProps, story);
    return child;
  }); // console.log(child);

  return React.createElement(BlockContainer, {
    "data-testid": dataTestid,
    title: title,
    collapsible: collapsible,
    id: id
  }, block);
};

var CURRENT_STORY = '.';

var getStoryTitle = function getStoryTitle(doc, component) {
  if (doc) {
    var titleParts = doc.title.split('/').filter(function (k) {
      return k;
    });
    return titleParts[titleParts.length - 1];
  } else if (component && component.info && component.info.displayName) {
    return component.info.displayName;
  }

  return undefined;
};

var getStoryBlockTitle = function getStoryBlockTitle(_ref) {
  var story = _ref.story,
      title = _ref.title;
  return title === CURRENT_STORY ? story === null || story === void 0 ? void 0 : story.name : title;
};

var repositoryActions = function repositoryActions(packageInfo) {
  if (packageInfo) {
    var _ref2 = packageInfo.repository || {},
        browse = _ref2.browse,
        docs = _ref2.docs,
        issues = _ref2.issues;

    if (browse || docs || issues) {
      var actions = [];

      if (browse) {
        actions.push({
          node: React.createElement(ExternalLink, {
            href: browse,
            "aria-label": "browse repository"
          }, "browse"),
          group: 'repository',
          id: 'browse'
        });
      }

      if (docs) {
        actions.push({
          node: React.createElement(ExternalLink, {
            href: docs,
            "aria-label": "browse readme documentation"
          }, "docs"),
          group: 'repository',
          id: 'docs'
        });
      }

      if (issues) {
        actions.push({
          node: React.createElement(ExternalLink, {
            href: issues,
            "aria-label": "browse filed issues"
          }, "issues"),
          group: 'repository',
          id: 'issues'
        });
      }

      return actions;
    }
  }

  return undefined;
};

var PlaygroundContext = createContext({
  useDescription: false
});

var StoryBlockContainer = function StoryBlockContainer(_a) {
  var story = _a.story,
      collapsible = _a.collapsible,
      userTitle = _a.title,
      children = _a.children,
      useStoryDescription = _a.useStoryDescription,
      userDescription = _a.description,
      dataTestid = _a['data-testid'],
      rest = __rest(_a, ["story", "collapsible", "title", "children", "useStoryDescription", "description", 'data-testid']);

  var playground = useContext(PlaygroundContext);
  var title = getStoryBlockTitle({
    story: story,
    title: userTitle
  });
  var description = playground === undefined && userDescription || (useStoryDescription ? story === null || story === void 0 ? void 0 : story.description : undefined);
  return jsx(BlockContainer, Object.assign({
    "data-testid": dataTestid,
    title: title,
    collapsible: collapsible,
    id: userTitle === CURRENT_STORY && story ? "".concat(dataTestid ? "".concat(dataTestid, "-") : '').concat(story.id) : undefined,
    description: description,
    plain: true
  }, rest), children);
};

var ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inherits(ErrorBoundary, _Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary() {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    _this = _super.apply(this, arguments);
    _this.state = {
      error: undefined
    };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, info) {
      this.setState({
        error: error || new Error('ERROR WAS NOT PROPAGATED')
      });
      console.error(error, info);
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var error = this.state.error;

      if (error) {
        console.log(error);
        return React.createElement("h1", null, "Unexpected error.");
      }

      return children;
    }
  }]);

  return ErrorBoundary;
}(Component);

var ThemeProvider = function ThemeProvider(props) {
  var theme = useTheme();
  return React.createElement(ThemeProvider$1, Object.assign({
    theme: theme
  }, props));
};

var getURL = function getURL() {
  var pageURL = undefined;

  if (typeof window !== 'undefined') {
    if (window.location !== window.parent.location && window.parent.location) {
      pageURL = window.parent.location.href;
    } else {
      pageURL = document.location.href;
    }
  }

  return pageURL ? new URL(pageURL) : undefined;
};

var BlockContextProvider = function BlockContextProvider(_a) {
  var children = _a.children,
      components = _a.components,
      props = __rest(_a, ["children", "components"]);

  var values = useMemo(function () {
    var url = getURL();

    if (url) {
      var parsedParams = queryString.parse(url.search);

      if (typeof parsedParams.controls === 'string') {
        return typeof parsedParams.controls === 'string' ? JSON.parse(parsedParams.controls) : parsedParams.controls;
      }
    }

    return undefined;
  }, []);
  return React.createElement(StateRoot, Object.assign({
    values: values
  }, props), React.createElement(ErrorBoundary, null, React.createElement(ThemeProvider, {
    components: components
  }, children)));
};

var useCustomProps = function useCustomProps(name, props) {
  var _a;

  var store = useStore();
  var config = store.config;
  var userProps = (_a = config.components) === null || _a === void 0 ? void 0 : _a[name];
  return userProps ? deepMerge(props, userProps) : props;
};
/* eslint-disable react/display-name */

/**
 * Displays commit history for a component
 */


var BaseComponentCommits = function BaseComponentCommits(_ref3) {
  var component = _ref3.component,
      _ref3$pagination = _ref3.pagination,
      pagination = _ref3$pagination === void 0 ? true : _ref3$pagination;

  var _a, _b, _c;

  var config = useConfig();
  var tokens = config.tokens;
  var componentPackage = usePackage(component === null || component === void 0 ? void 0 : component.package);
  var baseGitURL = (_b = (_a = componentPackage === null || componentPackage === void 0 ? void 0 : componentPackage.repository) === null || _a === void 0 ? void 0 : _a.issues) === null || _b === void 0 ? void 0 : _b.replace('issues', 'commit');
  var columns = useMemo(function () {
    return [{
      Header: 'Date',
      accessor: 'authorDate',
      Cell: function Cell(_ref4) {
        var authorDate = _ref4.row.original.authorDate;
        return jsx("span", null, authorDate ? dateToLocalString(new Date(authorDate)) : 'N/A');
      }
    }, {
      Header: 'Author',
      accessor: 'authorName',
      Cell: function Cell(_ref5) {
        var authorName = _ref5.row.original.authorName;
        return authorName ? jsx("div", {
          style: {
            display: 'flex'
          }
        }, jsx("p", {
          style: {
            paddingRight: '10px'
          }
        }, authorName), jsx(GithubAvatar, {
          username: authorName,
          size: 22,
          githubAccessToken: tokens === null || tokens === void 0 ? void 0 : tokens.githubAccessToken
        })) : null;
      }
    }, {
      Header: 'Commit Message',
      accessor: 'subject',
      Cell: function Cell(_ref6) {
        var _ref6$row$original = _ref6.row.original,
            subject = _ref6$row$original.subject,
            hash = _ref6$row$original.hash;
        return jsx(Fragment, null, jsx("span", {
          sx: {
            mr: 1
          }
        }, subject), baseGitURL && hash && jsx("span", null, jsx(ExternalLink, {
          href: "".concat(baseGitURL, "/").concat(hash),
          "aria-label": "View commit on GitHub"
        }, jsx(GitCommitIcon, {
          size: 16
        }))));
      }
    }];
  }, [baseGitURL, tokens === null || tokens === void 0 ? void 0 : tokens.githubAccessToken]);

  if (!((_c = component === null || component === void 0 ? void 0 : component.fileInfo) === null || _c === void 0 ? void 0 : _c.commits)) {
    return null;
  }

  return jsx(Table, {
    sorting: true,
    data: component.fileInfo.commits,
    columns: columns,
    sortBy: [{
      id: 'authorDate',
      desc: true
    }],
    pagination: pagination
  });
};
/**
 * Displays commit history for a component
 */


var ComponentCommits = function ComponentCommits(_a) {
  var _b;

  var id = _a.id,
      name = _a.name,
      _a$pagination = _a.pagination,
      pagination = _a$pagination === void 0 ? {
    totalCountTemplate: '${totalData} commits'
  } : _a$pagination,
      rest = __rest(_a, ["id", "name", "pagination"]);

  var props = useCustomProps('commits', rest);
  var component = useStoryComponent({
    id: id,
    name: name
  });

  if (!((_b = component === null || component === void 0 ? void 0 : component.fileInfo) === null || _b === void 0 ? void 0 : _b.commits)) {
    return null;
  }

  return jsx(BlockContainer, Object.assign({}, props), jsx(BaseComponentCommits, {
    component: component,
    pagination: pagination
  }));
};
/**
 * link displaying the total commits on a component
 * with a popover on click that will display the list of commits
 */


var CommitsPopover = function CommitsPopover(_ref7) {
  var component = _ref7.component;

  var _a, _b, _c, _d;

  return !!((_b = (_a = component === null || component === void 0 ? void 0 : component.fileInfo) === null || _a === void 0 ? void 0 : _a.commits) === null || _b === void 0 ? void 0 : _b.length) ? jsx(Popover, {
    trigger: "click",
    placement: "auto",
    tooltip: function tooltip() {
      return jsx(Box, {
        sx: {
          padding: 1
        }
      }, jsx(BaseComponentCommits, {
        component: component,
        pagination: {
          pageSize: 3
        }
      }));
    }
  }, jsx(Link, {
    sx: {
      ':hover': {
        cursor: 'pointer'
      }
    }
  }, jsx(Value, {
    label: jsx(Box, {
      sx: {
        fontSize: 0,
        mr: 1,
        lineHeight: 'heading',
        textDecoration: 'underline'
      }
    }, "commits:"),
    value: (_d = (_c = component.fileInfo) === null || _c === void 0 ? void 0 : _c.commits) === null || _d === void 0 ? void 0 : _d.length
  }))) : null;
};

var ComponentContributors = function ComponentContributors(_a) {
  var _b;

  var caption = _a.caption,
      component = _a.component,
      rest = __rest(_a, ["caption", "component"]);

  var props = useCustomProps('component_contributors', rest);
  var config = useConfig();
  var tokens = config.tokens;
  var contributors = useMemo(function () {
    var _a, _b;

    if (!((_b = (_a = component === null || component === void 0 ? void 0 : component.fileInfo) === null || _a === void 0 ? void 0 : _a.commits) === null || _b === void 0 ? void 0 : _b.length)) {
      return [];
    }

    return component.fileInfo.commits.reduce(function (acc, commit) {
      if (!acc.find(function (a) {
        return a.username === commit.authorName;
      })) {
        if (commit.authorName) {
          acc.push({
            username: commit.authorName,
            useremail: commit.authorEmail
          });
        }
      }

      if (!acc.find(function (a) {
        return a.username === commit.committerName;
      })) {
        if (commit.committerName) {
          acc.push({
            username: commit.committerName,
            useremail: commit.committerEmail
          });
        }
      }

      return acc;
    }, []);
  }, [(_b = component === null || component === void 0 ? void 0 : component.fileInfo) === null || _b === void 0 ? void 0 : _b.commits]);
  return !!contributors.length ? jsx("div", {
    sx: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    }
  }, caption && jsx("div", {
    sx: {
      mr: 1
    }
  }, caption), jsx(GithubAvatarList, Object.assign({
    githubAccessToken: tokens === null || tokens === void 0 ? void 0 : tokens.githubAccessToken,
    users: contributors,
    size: 24
  }, props))) : null;
};
/**
 *
 * displays a package npm link and version
 */


var PackageLink = function PackageLink(_ref8) {
  var name = _ref8.name,
      _ref8$dependencies = _ref8.dependencies,
      dependencies = _ref8$dependencies === void 0 ? {} : _ref8$dependencies,
      _ref8$devDependencies = _ref8.devDependencies,
      devDependencies = _ref8$devDependencies === void 0 ? {} : _ref8$devDependencies,
      version = _ref8.version;
  var dependenciesKeys = Object.keys(dependencies);
  var devDependenciesKeys = Object.keys(devDependencies);
  var packageName = dependenciesKeys && dependenciesKeys.find(function (packageName) {
    return name.startsWith(packageName);
  }) || devDependenciesKeys && devDependenciesKeys.find(function (packageName) {
    return name.startsWith(packageName);
  }) || name;
  var packageVersion = version || (packageName ? dependencies[packageName] || devDependencies[packageName] : '');
  var el = jsx(Box, {
    sx: {
      whiteSpace: 'nowrap'
    }
  }, name);

  if (!packageName || !packageVersion) {
    return el;
  }

  var baseVersion = packageVersion.replace(/[\^=~]/, '');
  return jsx(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      my: 1
    }
  }, jsx(ExternalLink, {
    href: "https://npmjs.com/package/".concat(packageName, "/v/").concat(baseVersion)
  }, el), jsx(Tag, {
    variant: "tag.small",
    sx: {
      ml: 2
    },
    color: "lightblue",
    borderSize: 1
  }, packageVersion));
};
/* eslint-disable react/display-name */

/**
 * base component dependencies
 */


var ComponentExternalDependencies = function ComponentExternalDependencies(_ref9) {
  var component = _ref9.component;
  var componentPackage = usePackage(component === null || component === void 0 ? void 0 : component.package);

  var _ref10 = componentPackage || {},
      _ref10$dependencies = _ref10.dependencies,
      dependencies = _ref10$dependencies === void 0 ? {} : _ref10$dependencies,
      _ref10$devDependencie = _ref10.devDependencies,
      devDependencies = _ref10$devDependencie === void 0 ? {} : _ref10$devDependencie,
      _ref10$peerDependenci = _ref10.peerDependencies,
      peerDependencies = _ref10$peerDependenci === void 0 ? {} : _ref10$peerDependenci;

  var _ref11 = component || {},
      _ref11$externalDepend = _ref11.externalDependencies,
      imports = _ref11$externalDepend === void 0 ? {} : _ref11$externalDepend;

  var columns = useMemo(function () {
    return [{
      Header: 'package',
      accessor: 'name',
      Cell: function Cell(_ref12) {
        var name = _ref12.row.original.name;
        return jsx(PackageLink, {
          name: name,
          dependencies: dependencies,
          devDependencies: devDependencies
        });
      }
    }, {
      Header: 'imports',
      accessor: 'imports',
      width: '70%',
      Cell: function Cell(_ref13) {
        var value = _ref13.value;
        return jsx(Flex, {
          sx: {
            flexWrap: 'wrap'
          }
        }, value.map(function (v) {
          return jsx(Tag, {
            variant: "tag.rightmargin",
            key: "".concat(v.name),
            borderSize: 1,
            color: v.importedName === defaultExport ? 'orange' : 'lightgrey'
          }, v.importedName === defaultExport ? v.name : v.importedName);
        }));
      }
    }, {
      Header: 'peer',
      accessor: 'peer',
      Cell: function Cell(_ref14) {
        var value = _ref14.value;
        return value ? '*' : '';
      }
    }];
  }, [dependencies, devDependencies]);
  var rows = useMemo(function () {
    var dependenciesKeys = Object.keys(dependencies);
    var devDependenciesKeys = Object.keys(devDependencies);
    var peerDependenciesKeys = peerDependencies && Object.keys(peerDependencies);
    return Object.keys(imports).map(function (name) {
      var packageName = dependenciesKeys && dependenciesKeys.find(function (packageName) {
        return name.startsWith(packageName);
      }) || devDependenciesKeys && devDependenciesKeys.find(function (packageName) {
        return name.startsWith(packageName);
      });
      return {
        name: name,
        imports: _toConsumableArray(imports[name]).sort(function (a, b) {
          if (a.importedName === defaultExport) {
            return -1;
          } else if (b.importedName === defaultExport) {
            return 1;
          }

          if (a.importedName > b.importedName) {
            return -1;
          } else if (a.importedName < b.importedName) {
            return 1;
          }

          return 0;
        }),
        peer: packageName ? peerDependenciesKeys.includes(packageName) : false
      };
    }).sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });
  }, [dependencies, devDependencies, imports, peerDependencies]);

  if (!imports) {
    return null;
  }

  return jsx(Table, {
    data: rows,
    columns: columns
  });
};
/**
 * Displays external dependencies for a component
 */


var ExternalDependencies = function ExternalDependencies(fullProps) {
  var props = useCustomProps('external_dependencies', fullProps);
  var component = useComponent({
    of: props.of
  });

  if (!component) {
    return null;
  }

  var externalDependencies = component.externalDependencies;

  if (!externalDependencies || !Object.keys(externalDependencies).length) {
    return null;
  }

  return React.createElement(ComponentsBlockContainer, Object.assign({}, props), function (component, rest) {
    return React.createElement(ComponentExternalDependencies, Object.assign({
      component: component
    }, rest));
  });
};
/* eslint-disable react/display-name */


var LocalImport = function LocalImport(_ref15) {
  var componentHash = _ref15.componentHash,
      name = _ref15.name;
  var store = useStore();
  var storypath = useMemo(function () {
    var _a;

    var docId = componentHash && Object.keys(store.docs).find(function (id) {
      var doc = store.docs[id];
      return (doc === null || doc === void 0 ? void 0 : doc.componentsLookup) ? Object.values(doc === null || doc === void 0 ? void 0 : doc.componentsLookup).includes(componentHash) : false;
    });

    if (!docId) {
      // if we can not find it by id - example theme-ui exports both named and default exports
      docId = name && Object.keys(store.docs).find(function (id) {
        var doc = store.docs[id];
        return (doc === null || doc === void 0 ? void 0 : doc.componentsLookup) ? Object.keys(doc === null || doc === void 0 ? void 0 : doc.componentsLookup).includes(name) : false;
      });
    }

    if (docId) {
      var doc = store.docs[docId];
      var storyId = undefined;

      if ((_a = doc === null || doc === void 0 ? void 0 : doc.stories) === null || _a === void 0 ? void 0 : _a.length) {
        storyId = doc === null || doc === void 0 ? void 0 : doc.stories[0];
      }

      return (storyId || doc) && formatStoryPath(getStoryPath(storyId, doc, store));
    }

    return undefined;
  }, [store, componentHash, name]);
  var displayName = name;
  return displayName ? jsx(Tag, {
    variant: "tag.rightmargin",
    key: "".concat(name),
    borderSize: 1,
    color: storypath ? 'green' : 'lightgrey',
    sx: {
      fontSize: 1,
      lineHeight: '1.2rem'
    }
  }, storypath ? jsx(Link$1, {
    href: storypath
  }, displayName) : displayName) : null;
};
/** @jsx jsx */

/**
 * Display a label with the component's package version.
 * extracted from package.json
 */


var PackageVersion = function PackageVersion(props) {
  var component = useComponent(props);
  var componentPackage = usePackage(component === null || component === void 0 ? void 0 : component.package);
  return (componentPackage === null || componentPackage === void 0 ? void 0 : componentPackage.name) && componentPackage.privateNpm !== true ? jsx(PackageLink, {
    name: componentPackage.name,
    version: componentPackage.version
  }) : null;
};
/* eslint-disable react/display-name */

/**
 * base component dependencies
 */


var ComponentLocalDependencies = function ComponentLocalDependencies(_ref16) {
  var component = _ref16.component;
  var imports = useMemo(function () {
    var _ref17 = component || {},
        localDependencies = _ref17.localDependencies;

    return localDependencies ? Object.keys(localDependencies).reduce(function (acc, key) {
      return [].concat(_toConsumableArray(acc), [{
        from: key,
        imports: localDependencies[key]
      }]);
    }, []) : [];
  }, [component]);
  var columns = useMemo(function () {
    return [{
      Header: 'file',
      accessor: 'name',
      Cell: function Cell(_ref18) {
        var from = _ref18.row.original.from;
        return jsx(Text, {
          sx: {
            fontSize: 1,
            lineHeight: '1.2rem',
            whiteSpace: 'nowrap'
          }
        }, "\"".concat(from, "\""));
      }
    }, {
      Header: 'imports',
      accessor: 'imports',
      Cell: function Cell(_ref19) {
        var value = _ref19.value;
        return jsx(Flex, {
          sx: {
            flexWrap: 'wrap'
          }
        }, value.map(function (node) {
          return jsx(LocalImport, {
            key: "".concat(node.name),
            componentHash: node.componentKey,
            name: node.name
          });
        }));
      }
    }];
  }, []);

  if (!imports) {
    return null;
  }

  return jsx(Table, {
    "data-testid": "local-dependencies",
    data: imports,
    columns: columns
  });
};
/**
 * Displays local dependencies for a component
 */


var LocalDependencies = function LocalDependencies(fullProps) {
  var props = useCustomProps('local_dependencies', fullProps);
  var component = useComponent({
    of: props.of
  });

  if (!component) {
    return null;
  }

  var localDependencies = component.localDependencies;

  if (!localDependencies || !Object.keys(localDependencies).length) {
    return null;
  }

  return React.createElement(ComponentsBlockContainer, Object.assign({
    visibility: "info"
  }, props), function (component, rest) {
    return React.createElement(ComponentLocalDependencies, Object.assign({
      component: component
    }, rest));
  });
};

var JSXTreeNode = function JSXTreeNode(_ref20) {
  var node = _ref20.node,
      isExpanded = _ref20.isExpanded;

  var _a, _b;

  return jsx(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'row',
      width: '100%',
      alignItems: 'center',
      color: 'secondary'
    }
  }, jsx(Text, {
    variant: "small",
    sx: {
      fontWeight: 'bold'
    }
  }, "<".concat(node.name)), jsx(Box, {
    sx: {
      pr: 1,
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      color: 'primary'
    }
  }, (_a = node.attributes) === null || _a === void 0 ? void 0 : _a.map(function (attr) {
    return jsx(Tag, {
      variant: "tag.small",
      key: "".concat(attr),
      borderSize: 0,
      color: "lightgrey"
    }, attr);
  })), jsx(Text, {
    variant: "small",
    sx: {
      fontWeight: 'bold'
    }
  }, "".concat(!isExpanded || !((_b = node.children) === null || _b === void 0 ? void 0 : _b.length) ? '/>' : '>')));
};
/** @jsx jsx */


var ImportLabel = function ImportLabel(_ref21) {
  var node = _ref21.node;
  return jsx(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    }
  }, jsx(LocalImport, {
    name: node.name,
    componentHash: node.componentKey
  }), node.from && jsx(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'baseline'
    }
  }, jsx(Text, {
    sx: {
      mx: 1,
      fontSize: 0,
      lineHeight: '1.2rem'
    }
  }, "from"), jsx(Text, {
    sx: {
      fontSize: 1,
      lineHeight: '1.2rem',
      whiteSpace: 'nowrap'
    }
  }, "\"".concat(node.from, "\""))));
};
/* eslint-disable react/display-name */


var ACTIONS;

(function (ACTIONS) {
  ACTIONS["SET"] = "SET_ROWS";
  ACTIONS["SET_STATS"] = "SET_STATS";
})(ACTIONS || (ACTIONS = {}));

var reducer = function reducer(state, action) {
  switch (action.type) {
    case ACTIONS.SET:
      return Object.assign(Object.assign({}, state), {
        rows: action.data.rows
      });

    case ACTIONS.SET_STATS:
      return Object.assign(Object.assign({}, state), {
        canExpand: action.data.canExpand,
        canCollapse: action.data.canCollapse,
        total: action.data.total
      });

    default:
      throw new Error();
  }
};
/**
 * base component dependencies
 */


var ComponentJSXTree = function ComponentJSXTree(_ref22) {
  var component = _ref22.component;

  var _useReducer = useReducer(reducer, {
    rows: undefined,
    canExpand: false,
    canCollapse: false,
    total: 0
  }),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      _useReducer2$ = _useReducer2[0],
      rows = _useReducer2$.rows,
      canExpand = _useReducer2$.canExpand,
      canCollapse = _useReducer2$.canCollapse,
      total = _useReducer2$.total,
      dispatch = _useReducer2[1];

  var componentPackage = usePackage(component === null || component === void 0 ? void 0 : component.package);

  var updateStats = function updateStats(items) {
    var _getTreeItemsStats = getTreeItemsStats(items || []),
        total = _getTreeItemsStats.total,
        expanded = _getTreeItemsStats.expanded;

    dispatch({
      type: ACTIONS.SET_STATS,
      data: {
        total: total,
        canExpand: expanded < total,
        canCollapse: expanded > 0 && expanded <= total
      }
    });
  };

  useEffect(function () {
    var _ref23 = component || {},
        jsx = _ref23.jsx;

    var _ref24 = componentPackage || {},
        dependencies = _ref24.dependencies,
        devDependencies = _ref24.devDependencies;

    var treeToItems = function treeToItems(tree) {
      var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var parentIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      return tree.length ? tree.map(function (item, index) {
        return {
          id: "".concat(item.name, "-").concat(level, "-").concat(parentIndex, "-").concat(index),
          label: function label(_ref25) {
            var isExpanded = _ref25.isExpanded;
            return React.createElement(JSXTreeNode, {
              node: item,
              isExpanded: isExpanded
            });
          },
          widget: item.from && !isLocalImport(item.from) ? React.createElement(PackageLink, {
            name: item.from,
            dependencies: dependencies,
            devDependencies: devDependencies
          }) : React.createElement(ImportLabel, {
            node: item
          }),
          expanded: level <= 1,
          items: item.children ? treeToItems(item.children, level + 1, index) : undefined
        };
      }) : undefined;
    };

    var newRows = jsx ? treeToItems(jsx) : undefined;
    dispatch({
      type: ACTIONS.SET,
      data: {
        rows: newRows
      }
    });
    updateStats(newRows);
  }, [component, componentPackage]);
  var actions = useMemo(function () {
    var actions = [];

    if (canCollapse) {
      actions.push({
        id: 'collapse_all',
        node: 'collapse all',
        'arial-label': 'collapse all jsx nodes',
        onClick: function onClick() {
          if (rows) {
            var collapsed = expandTreeItems(rows, false);
            dispatch({
              type: ACTIONS.SET,
              data: {
                rows: collapsed
              }
            });
            updateStats(collapsed);
          }
        }
      });
    }

    if (canExpand) {
      actions.push({
        id: 'expand_all',
        node: 'expand all',
        'arial-label': 'expand all jsx nodes',
        onClick: function onClick() {
          if (rows) {
            var expanded = expandTreeItems(rows, true);
            dispatch({
              type: ACTIONS.SET,
              data: {
                rows: expanded
              }
            });
            updateStats(expanded);
          }
        }
      });
    }

    return actions;
  }, [rows, canExpand, canCollapse]);

  var onExpandCollapse = function onExpandCollapse(expandedCount) {
    dispatch({
      type: ACTIONS.SET_STATS,
      data: {
        total: total,
        canExpand: expandedCount < total,
        canCollapse: expandedCount > 0
      }
    });
  };

  return rows ? React.createElement(ActionContainer, {
    actions: actions
  }, React.createElement(Tree, {
    sx: {
      mt: 4,
      mb: 2
    },
    "data-testid": "component-jsx",
    arrowPosition: "start",
    onExpandCollapse: onExpandCollapse,
    items: rows,
    chevronIcon: React.createElement(TriangleDownIcon, null),
    indentPixels: 16,
    rowLinkClass: Box
  })) : null;
};

var NAME = 'component_jsx';
/**
 * Displays external dependencies for a component
 */

var ComponentJSX = function ComponentJSX(fullProps) {
  var _a;

  var props = useCustomProps(NAME, fullProps);
  var component = useComponent({
    of: props.of
  });

  if (!((_a = component === null || component === void 0 ? void 0 : component.jsx) === null || _a === void 0 ? void 0 : _a.length)) {
    return null;
  }

  return React.createElement(ComponentsBlockContainer, Object.assign({}, props), function (component, rest) {
    return React.createElement(ComponentJSXTree, Object.assign({
      component: component
    }, rest));
  });
};

var NAME$1 = 'componentsource';

var getNextState = function getNextState(current, component) {
  switch (current) {
    case 'import':
      return component.source ? 'source' : 'import';

    case 'source':
      return 'import';

    default:
      return 'import';
  }
};

var BaseComponentSource = function BaseComponentSource(props) {
  var _a;

  var _useState3 = useState('import'),
      _useState4 = _slicedToArray(_useState3, 2),
      showType = _useState4[0],
      setShowType = _useState4[1];

  var custom = useCustomProps(NAME$1, props);

  var component = custom.component,
      actions = custom.actions,
      rest = __rest(custom, ["component", "actions"]);

  var componentPackage = usePackage(component === null || component === void 0 ? void 0 : component.package);

  if (!component) {
    return null;
  }

  var source;
  var from = component.from,
      importedName = component.importedName,
      componentName = component.name;
  var importFrom = componentPackage && componentPackage.name ? componentPackage.name : from;

  if (importFrom) {
    source = importedName !== 'default' && importedName !== 'namespace' ? "import { ".concat(componentName, " } from '").concat(importFrom, "';") : "import ".concat(componentName, " from '").concat(importFrom, "';");
  }

  if (!source) {
    return null;
  }

  var onShowClick = function onShowClick() {
    setShowType(getNextState(showType, component));
  };

  var allActions = [];

  if (component.source) {
    allActions.push({
      node: getNextState(showType, component),
      'aria-label': "view ".concat(component.name, " ").concat(getNextState(showType, component)),
      onClick: onShowClick
    });
  }

  var repositoryItems = component && repositoryActions(componentPackage);

  if (repositoryItems) {
    allActions.push.apply(allActions, _toConsumableArray(repositoryItems));
  }

  if (actions) {
    allActions.push.apply(allActions, _toConsumableArray(actions));
  }

  return jsx(Source, Object.assign({
    "data-testid": NAME$1
  }, rest, {
    actions: allActions
  }), showType === 'source' ? (_a = component === null || component === void 0 ? void 0 : component.source) !== null && _a !== void 0 ? _a : '' : source);
};
/**
 * Displays import statement for a component as well as the component file source code
 * Optionally also displays some repository information from the component's package.json
 */


var ComponentSource = function ComponentSource(props) {
  return React.createElement(ComponentsBlockContainer, Object.assign({
    visibility: "info"
  }, props), function (component, sourceProps) {
    return React.createElement(BaseComponentSource, Object.assign({
      component: component
    }, sourceProps));
  });
};

var ComponentStats = function ComponentStats(_a) {
  var _b;

  var component = _a.component,
      rest = __rest(_a, ["component"]);

  if (!component) {
    return null;
  }

  var stats = (_b = component.fileInfo) === null || _b === void 0 ? void 0 : _b.sloc;
  var statsNode = stats && jsx(Fragment, null, jsx(Shield, {
    title: "total lines of code",
    label: "loc",
    value: stats.source
  }), jsx(Shield, {
    label: "comments",
    title: "percentage comments to lines of code",
    value: stats.source ? Math.round(100 * stats.comment / stats.source) : 0,
    percent: true
  }), !!stats.todo && jsx(Shield, {
    title: "total todo comments",
    label: "todos",
    value: stats.todo
  }));
  var jest = component.jest;
  var jestNode;

  if (jest) {
    var minCovField = Object.values(jest.coverage).reduce(function (acc, cov) {
      Object.keys(cov).forEach(function (key) {
        var kind = key;

        if (acc.pct > cov[kind].pct) {
          acc = {
            field: kind,
            pct: cov[kind].pct
          };
        }
      });
      return acc;
    }, {
      field: 'lines',
      pct: 101
    });
    var coverage = Object.values(jest.coverage).reduce(function (acc, cov) {
      return {
        total: acc.total + cov[minCovField.field].total,
        covered: acc.covered + cov[minCovField.field].covered
      };
    }, {
      total: 0,
      covered: 0
    });
    var tests = jest.results.reduce(function (acc, result) {
      return {
        passed: acc.passed + result.testResults.filter(function (r) {
          return r.status === 'passed';
        }).length,
        failed: acc.failed + result.testResults.filter(function (r) {
          return r.status === 'failed';
        }).length
      };
    }, {
      passed: 0,
      failed: 0
    });
    jestNode = jsx(Fragment, null, !!tests.passed && jsx(Shield, {
      label: "passed",
      title: "number of passed tests",
      value: tests.passed,
      color: "status_passed"
    }), !!tests.failed && jsx(Shield, {
      label: "failed",
      title: "number of failed tests",
      value: tests.failed,
      color: "status_failed"
    }), !!coverage.total && jsx(Shield, {
      label: "coverage",
      title: "tests coverage by ".concat(minCovField.field),
      value: coverage.total ? (100 * (coverage.covered / coverage.total)).toFixed(0) : '0',
      percent: true
    }));
  }

  return statsNode || jestNode ? jsx(Box, Object.assign({
    variant: "componentstats.container"
  }, rest), statsNode, jestNode) : null;
};
/**
 * Displays data-drven table of data rows
 */


var BaseStoryData = function BaseStoryData(_ref26) {
  var storyId = _ref26.storyId,
      values = _ref26.values,
      _ref26$pagination = _ref26.pagination,
      pagination = _ref26$pagination === void 0 ? true : _ref26$pagination;

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      controlValues = _useState6[0],
      setControlValues = _useState6[1];

  var columns = useMemo(function () {
    var columns = [{
      Header: 'select',
      id: '__data_row_select',
      Cell: function Cell(_ref27) {
        var original = _ref27.row.original;

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var data = __rest(original, ["id"]);

        return jsx(Link, {
          title: "click to select this row of values",
          href: "#",
          onClick: function onClick(e) {
            e.preventDefault();
            setControlValues(data);
          }
        }, jsx(UploadIcon, null));
      }
    }, {
      Header: '#',
      accessor: '__data_row_id',
      Cell: function Cell(_ref28) {
        var _ref28$row = _ref28.row,
            id = _ref28$row.original.id,
            isExpanded = _ref28$row.isExpanded,
            getToggleRowExpandedProps = _ref28$row.getToggleRowExpandedProps;
        return jsx("div", Object.assign({
          sx: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
          }
        }, getToggleRowExpandedProps()), id, jsx("div", null, isExpanded ? jsx(TriangleDownIcon, {
          size: 24
        }) : jsx(TriangleRightIcon, {
          size: 24
        })));
      }
    }];

    if (values) {
      var keys = Object.keys(values);

      if (keys.length > 0) {
        Object.keys(values[keys[0]]).forEach(function (key) {
          columns.push({
            Header: key,
            accessor: key,
            Cell: function Cell(_ref29) {
              var _ref29$row = _ref29.row,
                  original = _ref29$row.original,
                  getToggleRowExpandedProps = _ref29$row.getToggleRowExpandedProps;
              return jsx("div", {
                sx: {
                  whiteSpace: 'nowrap',
                  maxWidth: '450px',
                  textOverflow: 'ellipsis'
                }
              }, typeof original[key] !== 'object' ? original[key] : jsx("div", Object.assign({}, getToggleRowExpandedProps()), "..."));
            }
          });
        });
      }
    }

    return columns;
  }, [values]);
  var data = useMemo(function () {
    if (values) {
      var fields = Object.keys(values);
      return fields.reduce(function (acc, key) {
        var v = (values === null || values === void 0 ? void 0 : values[key]) || {};
        return [].concat(_toConsumableArray(acc), [Object.assign({
          id: key
        }, Object.keys(v).reduce(function (accValues, valueKey) {
          return Object.assign(Object.assign({}, accValues), _defineProperty({}, valueKey, v[valueKey]));
        }, {}))]);
      }, []);
    }

    return [];
  }, [values]);

  if (!values) {
    return null;
  }

  var renderRowSubComponent = useCallback(function (_ref30) {
    var row = _ref30.row;
    return jsx("div", {
      sx: {
        pre: {
          maxWidth: 'unset'
        },
        px: 2
      }
    }, jsx("pre", null, JSON.stringify(row.original, null, 2)));
  }, []);
  return jsx(StoryContextProvider, {
    storyId: storyId,
    values: controlValues
  }, jsx(Table, {
    itemsLabel: "data",
    sorting: true,
    data: data,
    columns: columns,
    pagination: pagination,
    renderRowSubComponent: renderRowSubComponent
  }));
};
/**
 * Displays document data associated with a story
 */


var StoryData = function StoryData(_a) {
  var _b;

  var id = _a.id,
      name = _a.name,
      _a$pagination2 = _a.pagination,
      pagination = _a$pagination2 === void 0 ? {
    totalCountTemplate: '${totalData} data rows'
  } : _a$pagination2,
      rest = __rest(_a, ["id", "name", "pagination"]);

  var props = useCustomProps('story_data', rest);
  var story = useStory({
    id: id,
    name: name
  });
  var doc = useDocument(story === null || story === void 0 ? void 0 : story.doc);

  if (!story || !story.id || !story.rawId || !((_b = doc === null || doc === void 0 ? void 0 : doc.data) === null || _b === void 0 ? void 0 : _b[story.rawId])) {
    return null;
  }

  return jsx(BlockContainer, Object.assign({}, props), jsx(BaseStoryData, {
    storyId: story.id,
    values: doc.data[story.rawId],
    pagination: pagination
  }));
};
/* eslint-disable react/display-name */

/**
 * Displays jest tests coverage for a component
 */


var BaseTestsCoverage = function BaseTestsCoverage(_ref31) {
  var component = _ref31.component,
      _ref31$pagination = _ref31.pagination,
      pagination = _ref31$pagination === void 0 ? {
    totalCountVisible: false
  } : _ref31$pagination;

  var _a, _b, _c;

  var theme = useTheme$1();
  var columns = useMemo(function () {
    return [{
      Header: 'Test file',
      accessor: 'filePath',
      Cell: function Cell(_ref32) {
        var value = _ref32.value;
        return jsx("div", null, value);
      }
    }, {
      Header: 'Kind',
      accessor: 'kind',
      Cell: function Cell(_ref33) {
        var value = _ref33.value;
        return jsx(Box, {
          sx: {
            fontWeight: 'heading'
          }
        }, value);
      }
    }, {
      Header: jsx("div", {
        sx: {
          textAlign: 'center'
        }
      }, "Total"),
      accessor: 'total',
      Cell: function Cell(_ref34) {
        var value = _ref34.value;
        return jsx("div", {
          sx: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end'
          }
        }, value);
      }
    }, {
      Header: jsx("div", {
        sx: {
          textAlign: 'center'
        }
      }, "Covered"),
      accessor: 'covered',
      Cell: function Cell(_ref35) {
        var value = _ref35.value;
        return jsx("div", {
          sx: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end'
          }
        }, value);
      }
    }, {
      Header: jsx("div", {
        sx: {
          textAlign: 'center'
        }
      }, "Skipped"),
      accessor: 'skipped',
      Cell: function Cell(_ref36) {
        var value = _ref36.value;
        return jsx("div", {
          sx: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end'
          }
        }, value);
      }
    }, {
      Header: jsx("div", {
        sx: {
          textAlign: 'center'
        }
      }, "%"),
      accessor: 'pct',
      Cell: function Cell(_ref37) {
        var value = _ref37.value;
        return (theme === null || theme === void 0 ? void 0 : theme.colors) ? jsx("div", {
          sx: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end'
          }
        }, jsx(Tag, {
          color: mix("".concat((value / 100).toFixed(1)), theme.colors.status_passed, theme.colors.status_failed)
        }, "".concat(value, "%"))) : null;
      }
    }];
  }, [theme.colors]);
  var data = useMemo(function () {
    var _a;

    var coverage = (_a = component === null || component === void 0 ? void 0 : component.jest) === null || _a === void 0 ? void 0 : _a.coverage;
    return coverage ? Object.keys(coverage).reduce(function (acc, key) {
      return [].concat(_toConsumableArray(acc), [Object.assign({
        filePath: key,
        kind: 'lines'
      }, coverage[key].lines), Object.assign({
        filePath: key,
        kind: 'functions'
      }, coverage[key].functions), Object.assign({
        filePath: key,
        kind: 'statements'
      }, coverage[key].statements), Object.assign({
        filePath: key,
        kind: 'branches'
      }, coverage[key].branches)]);
    }, []) : undefined;
  }, [(_a = component === null || component === void 0 ? void 0 : component.jest) === null || _a === void 0 ? void 0 : _a.coverage]);
  var expanded = useMemo(function () {
    var _a;

    return ((_a = component === null || component === void 0 ? void 0 : component.jest) === null || _a === void 0 ? void 0 : _a.coverage) ? Object.keys(component.jest.coverage).reduce(function (acc, filePath) {
      var key = "filePath:".concat(filePath);

      if (!acc[key]) {
        return Object.assign(Object.assign({}, acc), _defineProperty({}, key, true));
      }

      return acc;
    }, {}) : undefined;
  }, [(_b = component === null || component === void 0 ? void 0 : component.jest) === null || _b === void 0 ? void 0 : _b.coverage]);

  if (!((_c = component === null || component === void 0 ? void 0 : component.jest) === null || _c === void 0 ? void 0 : _c.coverage) || !Object.keys(component.jest.coverage).length) {
    return null;
  }

  return jsx(Table, {
    itemsLabel: null,
    sorting: true,
    data: data,
    columns: columns,
    expanded: expanded,
    groupBy: ['filePath'],
    pagination: pagination
  });
};
/**
 * Displays jest tests coverage for a component, within a block
 */


var TestsCoverage = function TestsCoverage(_a) {
  var _b;

  var id = _a.id,
      name = _a.name,
      pagination = _a.pagination,
      rest = __rest(_a, ["id", "name", "pagination"]);

  var props = useCustomProps('tests_coverage', rest);
  var component = useStoryComponent({
    id: id,
    name: name
  });

  if (!((_b = component === null || component === void 0 ? void 0 : component.jest) === null || _b === void 0 ? void 0 : _b.coverage) || !Object.keys(component.jest.coverage).length) {
    return null;
  }

  return jsx(BlockContainer, Object.assign({}, props), jsx(BaseTestsCoverage, {
    component: component,
    pagination: pagination
  }));
};
/**
 * Displays tests results details for a component
 */


var BaseTestsResults = function BaseTestsResults(_ref38) {
  var component = _ref38.component,
      _ref38$pagination = _ref38.pagination,
      pagination = _ref38$pagination === void 0 ? true : _ref38$pagination;

  var _a, _b, _c;

  var ansi_up = useMemo(function () {
    return new AnsiUp();
  }, []);
  var renderRowSubComponent = useCallback(function (_ref39) {
    var row = _ref39.row;
    var errors = row.original.failureDetails.map(function (failure, index) {
      return jsx("code", {
        key: "error_msg_".concat(index)
      }, jsx("div", {
        sx: {
          p: 2,
          whiteSpace: 'pre-wrap'
        },
        dangerouslySetInnerHTML: {
          __html: ansi_up.ansi_to_html(failure.message).replace(/\n/gi, '<div />')
        }
      }));
    });
    return jsx("div", null, jsx("div", null, errors));
  }, [ansi_up]);
  var columns = useMemo(function () {
    return [{
      Header: 'Status',
      accessor: 'status',
      Cell: function Cell(_ref40) {
        var _ref40$row = _ref40.row,
            isExpanded = _ref40$row.isExpanded,
            getToggleRowExpandedProps = _ref40$row.getToggleRowExpandedProps,
            _ref40$row$original = _ref40$row.original,
            status = _ref40$row$original.status,
            failureDetails = _ref40$row$original.failureDetails;
        var renderdStatus = jsx("div", null, status);
        return jsx(Tag, {
          color: "status_".concat(status)
        }, failureDetails.length > 0 ? jsx("div", Object.assign({
          sx: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center'
          }
        }, getToggleRowExpandedProps()), renderdStatus, jsx("div", null, isExpanded ? jsx(TriangleDownIcon, {
          size: 24
        }) : jsx(TriangleRightIcon, {
          size: 24
        }))) : renderdStatus);
      }
    }, {
      Header: 'Test file',
      accessor: 'testFilePath',
      Cell: function Cell(_ref41) {
        var testFilePath = _ref41.row.original.testFilePath;
        return jsx("div", null, testFilePath);
      }
    }, {
      Header: 'Full name',
      accessor: 'fullName',
      Cell: function Cell(_ref42) {
        var ancestorTitles = _ref42.row.original.ancestorTitles;
        return jsx("div", {
          sx: {
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            maxWidth: '400px'
          }
        }, ancestorTitles.join(' > '));
      }
    }, {
      Header: 'Title',
      accessor: 'title',
      Cell: function Cell(_ref43) {
        var title = _ref43.row.original.title;
        return jsx("div", {
          sx: {
            fontWeight: 'bolder'
          }
        }, title);
      }
    }, {
      Header: jsx("div", {
        sx: {
          textAlign: 'center'
        }
      }, "Time(ms)"),
      accessor: 'duration',
      Cell: function Cell(_ref44) {
        var duration = _ref44.row.original.duration;
        return jsx("div", {
          sx: {
            textAlign: 'end'
          }
        }, duration);
      }
    }];
  }, []);
  var data = useMemo(function () {
    var _a;

    return (_a = component === null || component === void 0 ? void 0 : component.jest) === null || _a === void 0 ? void 0 : _a.results.reduce(function (acc, _a) {
      var testResults = _a.testResults,
          rest = __rest(_a, ["testResults"]);

      return [].concat(_toConsumableArray(acc), _toConsumableArray(testResults.map(function (r, rowNum) {
        return Object.assign(Object.assign({
          id: acc.length + rowNum
        }, rest), r);
      })));
    }, []);
  }, [(_a = component === null || component === void 0 ? void 0 : component.jest) === null || _a === void 0 ? void 0 : _a.results]);
  var expanded = useMemo(function () {
    var _a;

    return (_a = component === null || component === void 0 ? void 0 : component.jest) === null || _a === void 0 ? void 0 : _a.results.reduce(function (acc, _ref45) {
      var testFilePath = _ref45.testFilePath;
      var key = "testFilePath:".concat(testFilePath);

      if (!acc[key]) {
        return Object.assign(Object.assign({}, acc), _defineProperty({}, key, true));
      }

      return acc;
    }, {});
  }, [(_b = component === null || component === void 0 ? void 0 : component.jest) === null || _b === void 0 ? void 0 : _b.results]);

  if (!((_c = component === null || component === void 0 ? void 0 : component.jest) === null || _c === void 0 ? void 0 : _c.results.length)) {
    return null;
  }

  return jsx(Table, {
    itemsLabel: "tests",
    sorting: true,
    data: data,
    columns: columns,
    expanded: expanded,
    groupBy: ['testFilePath'],
    renderRowSubComponent: renderRowSubComponent,
    pagination: pagination
  });
};
/**
 * Displays tests results details for a component, within a block
 */


var TestsResults = function TestsResults(_a) {
  var id = _a.id,
      name = _a.name,
      _a$pagination3 = _a.pagination,
      pagination = _a$pagination3 === void 0 ? {
    totalCountTemplate: 'total ${totalData} tests'
  } : _a$pagination3,
      rest = __rest(_a, ["id", "name", "pagination"]);

  var props = useCustomProps('tests_results', rest);
  var component = useStoryComponent({
    id: id,
    name: name
  });
  var totalTests = useMemo(function () {
    return (component === null || component === void 0 ? void 0 : component.jest) ? component.jest.results.reduce(function (acc, _ref46) {
      var testResults = _ref46.testResults;
      return acc + testResults.length;
    }, 0) : 0;
  }, [component === null || component === void 0 ? void 0 : component.jest]);

  if (!totalTests) {
    return null;
  }

  return jsx(BlockContainer, Object.assign({}, props), jsx(BaseTestsResults, {
    component: component,
    pagination: pagination
  }));
};
/**
 * displays a title as assigned to the story document
 */


var Title = function Title(_a) {
  var _b;

  var id = _a.id,
      name = _a.name,
      _a$contributors = _a.contributors,
      contributors = _a$contributors === void 0 ? true : _a$contributors,
      children = _a.children,
      rest = __rest(_a, ["id", "name", "contributors", "children"]);

  var story = useStory({
    id: id,
    name: name
  });
  var doc = useDocument(story === null || story === void 0 ? void 0 : story.doc);
  var component = useStoryComponent({
    id: id,
    name: name
  });
  var title = typeof children === 'string' ? children : getStoryTitle(doc, component);
  return title ? jsx("div", Object.assign({
    sx: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  }, rest), jsx(Themed.h1, null, title), ((_b = component === null || component === void 0 ? void 0 : component.info) === null || _b === void 0 ? void 0 : _b.displayName) === title && contributors && jsx(ComponentContributors, {
    component: component
  })) : null;
};
/**
 * displays a subtitle as assigned to the story parameters:
 * or story.subtitle
 *
 */


var Subtitle = function Subtitle(_a) {
  var id = _a.id,
      name = _a.name,
      rest = __rest(_a, ["id", "name"]);

  var story = useStory({
    id: id,
    name: name
  });
  var title = story ? story.subtitle : null;
  return title ? React.createElement(Subtitle$1, Object.assign({}, rest), title) : null;
};
/** @jsx jsx */

/**
 * Display a Edit this page link to the page source repository.
 * In order for this to work, you need to set up the `repository` field in `package.json`.
 */


var EditPage = function EditPage(props) {
  var docPackage = useDocPackage();
  return docPackage && docPackage.repository && docPackage.repository.browse ? jsx(Box, Object.assign({
    variant: "editpage.container"
  }, props), jsx(ExternalLink, {
    href: docPackage.repository.browse,
    "aria-label": "edit this page"
  }, jsx(Box, {
    variant: "editpage.inner"
  }, jsx(MarkGithubIcon, null), jsx(Text, {
    variant: "editpage.text"
  }, "Edit this page")))) : jsx("div", null);
};
/** @jsx jsx */

/**
 * page inner container. will display a like to edit the page and a last updated date.
 */


var Container = function Container(_ref47) {
  var children = _ref47.children,
      author = _ref47.author,
      secondRow = _ref47.secondRow;
  var doc = useCurrentDocument();
  var component = useStoryComponent({
    id: CURRENT_STORY$1
  });
  return jsx(Box, {
    variant: "blockpagecontainer.container"
  }, jsx(Box, {
    variant: "blockpagecontainer.inforow"
  }, jsx(EditPage, null), jsx(Box, {
    variant: "blockpagecontainer.createdbox.container"
  }, (doc === null || doc === void 0 ? void 0 : doc.date) && jsx(Value, {
    label: "created:",
    value: dateToLocalString(new Date(doc.date))
  }), (doc === null || doc === void 0 ? void 0 : doc.dateModified) && jsx(Value, {
    label: "updated:",
    value: dateToLocalString(new Date(doc.dateModified)),
    sx: {
      ml: 2
    }
  }), author)), jsx("div", {
    sx: {
      pt: 2
    }
  }, jsx(ComponentStats, {
    component: component
  })), secondRow && jsx(Box, {
    variant: "blockpagecontainer.secondrow"
  }, secondRow), jsx(Box, {
    variant: "blockpagecontainer.titlerow"
  }, jsx(Title, {
    sx: {
      pb: 0
    }
  })), jsx(Subtitle, null), children);
};
/**
 * Description component with markdown.
 * The 'of' property can specify which component's description to display.
 */


var Description = function Description(_a) {
  var of = _a.of,
      rest = __rest(_a, ["of"]);

  var components = useComponents({
    of: of
  });
  var doc = useCurrentDocument();
  return doc && doc.description ? typeof doc.description === 'string' ? React.createElement(Description$1, Object.assign({}, rest), doc.description) : doc.description : React.createElement(ComponentsContainer, {
    components: components
  }, function (component) {
    if (!component || !component.info || !component.info.description) {
      return null;
    }

    return React.createElement(Description$1, Object.assign({}, rest), component.info.description);
  });
};

var PageTypeTag = function PageTypeTag(_ref48) {
  var type = _ref48.type,
      raw = _ref48.raw;

  var _a;

  var store = useStore();
  var config = store.config;
  var tags = useDocPropCount('type');

  var _useState7 = useState({}),
      _useState8 = _slicedToArray(_useState7, 2),
      colors = _useState8[0],
      setColors = _useState8[1];

  useEffect(function () {
    setColors(Object.keys(tags).reduce(function (acc, key, index) {
      return Object.assign(Object.assign({}, acc), _defineProperty({}, key, getAccentPaletteColor(index)));
    }, {}));
  }, [tags]);
  return React.createElement(Link$1, {
    href: getDocTypePath(store, (_a = config.pages) === null || _a === void 0 ? void 0 : _a[type].basePath)
  }, React.createElement(Tag, {
    color: colors[type] || '#f49342',
    raw: raw
  }, type));
};
/**
 * displays a row of tags assigned to the current document, with links to their pages
 */


var TagsList = function TagsList(_a) {
  var tags = _a.tags,
      raw = _a.raw,
      _a$limit = _a.limit,
      limit = _a$limit === void 0 ? 0 : _a$limit,
      rest = __rest(_a, ["tags", "raw", "limit"]);

  var _useState9 = useState({}),
      _useState10 = _slicedToArray(_useState9, 2),
      tagColors = _useState10[0],
      setTagColors = _useState10[1];

  var tagCounts = useDocPropCount('tags');
  var store = useStore();
  useEffect(function () {
    setTagColors(Object.keys(tagCounts).reduce(function (acc, key, index) {
      return Object.assign(Object.assign({}, acc), _defineProperty({}, key, getPaletteColor(index)));
    }, {}));
  }, [tagCounts]);

  if (!tags) {
    return null;
  }

  var largerThanLimit = limit !== 0 && tags.length > limit;
  return jsx(Box, {
    variant: "taglist.container",
    sx: {
      maxWidth: largerThanLimit ? 'unset' : undefined
    }
  }, tags.slice(0, limit > 0 ? limit : undefined).map(function (tag, index) {
    var rawTag = raw ? raw[index] : undefined;
    return jsx(Link$1, {
      key: tag,
      href: getDocPath('tags', undefined, store, tag)
    }, jsx(Tag, Object.assign({
      color: tagColors[tag] || 'muted',
      variant: "tag.leftmargin",
      raw: rawTag
    }, rest), tag));
  }), limit > 0 && largerThanLimit && jsx(Tag, Object.assign({
    color: "muted",
    variant: "tag.leftmargin"
  }, rest), "...more"));
};
/**
 * displays a single doument item
 */


var DocumentItem = function DocumentItem(_a) {
  var item = _a.item,
      showImage = _a.showImage,
      rest = __rest(_a, ["item", "showImage"]);

  var title = item.title,
      description = item.description,
      _item$type = item.type,
      type = _item$type === void 0 ? defDocType : _item$type,
      rawType = item.rawType,
      _item$tags = item.tags,
      tags = _item$tags === void 0 ? [] : _item$tags,
      rawTags = item.rawTags,
      date = item.date,
      author = item.author,
      authorLink = item.authorLink,
      link = item.link,
      image = item.image;
  var dateNode = date ? jsx(Box, {
    variant: "documentitem.info.inner"
  }, date ? jsx(Box, {
    variant: "documentitem.info.date"
  }, "created: ".concat(dateToLocalString(new Date(date)))) : '', author && jsx(Box, {
    variant: "documentitem.info.author"
  }, date && jsx(Text, {
    variant: "documentitem.info.comma"
  }, ","), jsx(Text, {
    variant: "documentitem.info.by"
  }, "by"), jsx(Link$1, {
    href: authorLink
  }, jsx(Text, {
    dangerouslySetInnerHTML: {
      __html: author
    }
  })))) : null;
  var tagsNode = tags.length ? jsx(TagsList, {
    tags: tags,
    raw: rawTags,
    sx: {
      fontSize: 0,
      lineHeight: '1rem'
    }
  }) : null;
  return jsx(Box, Object.assign({
    variant: "documentitem.container"
  }, rest), showImage && image && jsx(Link$1, {
    href: link
  }, jsx(Box, {
    variant: "documentitem.imageBox"
  }, jsx(Image, {
    src: image,
    alt: title,
    variant: "documentitem.image"
  }))), jsx(Box, {
    variant: "documentitem.content"
  }, jsx(Box, {
    variant: "documentitem.titlerow"
  }, jsx(Link$1, {
    href: link
  }, jsx(Subtitle$1, {
    sx: {
      mr: 1
    },
    dangerouslySetInnerHTML: {
      __html: title
    }
  })), jsx(PageTypeTag, {
    type: type,
    raw: rawType
  })), description && typeof description === 'string' ? jsx(Markdown, null, description) : description, (tagsNode || dateNode) && jsx(Box, {
    variant: "documentitem.info.container"
  }, dateNode || jsx("div", null), tagsNode)));
};
/**
 * Page container component
 * If the page is an MDX page, will display the MDX components.
 * Otherwise, the page elements are passed as children
 */


var PageContainer = forwardRef(function PageContainer(_a, ref) {
  var _b;

  var children = _a.children,
      _a$wrapper = _a.wrapper,
      Wrapper = _a$wrapper === void 0 ? Container : _a$wrapper,
      rest = __rest(_a, ["children", "wrapper"]);

  useEffect(function () {
    var parseURLHash = function parseURLHash() {
      try {
        var url = getURL();

        if (url) {
          var scrollId = url.hash ? url.hash.substring(1) : undefined;

          if (scrollId) {
            var element = typeof document !== 'undefined' && document.getElementById(scrollId);

            if (element) {
              setTimeout(function () {
                element.scrollIntoView({
                  behavior: 'smooth',
                  block: 'start'
                });
              }, 100);
            }
          }
        }
      } catch (err) {}
    };

    parseURLHash();

    if (typeof window !== 'undefined' && window) {
      window.addEventListener('hashchange', parseURLHash, false);
    }

    return function () {
      if (typeof window !== 'undefined' && window) {
        window.removeEventListener('hashchange', parseURLHash, false);
      }
    };
  }, []);
  var doc = useCurrentDocument();

  var _ref49 = doc || {},
      MDXPage = _ref49.MDXPage,
      parameters = _ref49.parameters;

  var node = MDXPage ? jsx(MDXPage, null) : ((_b = parameters === null || parameters === void 0 ? void 0 : parameters.docs) === null || _b === void 0 ? void 0 : _b.page) ? parameters.docs.page() : children;
  return jsx(Box, Object.assign({
    ref: ref
  }, rest), Wrapper ? jsx(Wrapper, null, node) : node);
});
/** @jsx jsx */

/**
 * displays automatic pagination to the next/previous document of this same type.
 */

var Pagination = function Pagination() {
  var _useNavigationInfo = useNavigationInfo(),
      nextPage = _useNavigationInfo.nextPage,
      prevPage = _useNavigationInfo.prevPage;

  var prevLink = prevPage ? {
    title: prevPage.title,
    link: prevPage.link || ''
  } : undefined;
  var nextLink = nextPage ? {
    title: nextPage.title,
    link: nextPage.link
  } : undefined;
  return jsx(Pagination$1, {
    prev: prevLink,
    next: nextLink
  });
};

var NAME$2 = 'playground';

var BasePlayground = function BasePlayground(_a) {
  var children = _a.children,
      story = _a.story,
      isDark = _a.isDark,
      _a$wrapper2 = _a.wrapper,
      wrapper = _a$wrapper2 === void 0 ? true : _a$wrapper2,
      source = _a.source,
      props = __rest(_a, ["children", "story", "isDark", "wrapper", "source"]);

  var custom = useCustomProps(NAME$2, props);
  var title = custom.title,
      collapsible = custom.collapsible,
      description = custom.description,
      _custom$scale = custom.scale,
      userScale = _custom$scale === void 0 ? 1 : _custom$scale,
      _custom$actions = custom.actions,
      userActions = _custom$actions === void 0 ? [] : _custom$actions,
      openTab = custom.openTab,
      _custom$visibleTabs = custom.visibleTabs,
      visibleTabs = _custom$visibleTabs === void 0 ? false : _custom$visibleTabs;

  var _useState11 = useState(userScale),
      _useState12 = _slicedToArray(_useState11, 2),
      scale = _useState12[0],
      setScale = _useState12[1];

  var _useState13 = useState('light'),
      _useState14 = _slicedToArray(_useState13, 2),
      background = _useState14[0],
      setBackground = _useState14[1];

  var _useState15 = useState('ltr'),
      _useState16 = _slicedToArray(_useState15, 2),
      direction = _useState16[0],
      setDirection = _useState16[1];

  var tab = openTab;
  useEffect(function () {
    return setScale(userScale);
  }, [userScale]);
  var zoomActions = useMemo(function () {
    return [{
      node: React.createElement(IconButton, {
        onClick: function onClick() {
          return setScale(1);
        },
        "aria-label": "reset zoom"
      }, React.createElement(SyncIcon, null)),
      id: 'zoomreset',
      group: 'zoom'
    }, {
      node: React.createElement(IconButton, {
        onClick: function onClick() {
          return setScale(Math.max(0.5, scale - 0.2));
        },
        "aria-label": "zoom out"
      }, React.createElement(DashIcon, null)),
      id: 'zoomout',
      group: 'zoom'
    }, {
      node: React.createElement(IconButton, {
        onClick: function onClick() {
          return setScale(Math.min(3, scale + 0.2));
        },
        "aria-label": "zoom in"
      }, React.createElement(PlusIcon, null)),
      id: 'zoomin',
      group: 'zoom'
    }];
  }, [scale]);
  var layoutActions = [{
    node: background === 'light' ? 'dark' : 'light',
    id: 'background',
    group: 'story',
    'aria-label': 'switch light and dark background',
    onClick: function onClick() {
      return setBackground(background === 'light' ? 'dark' : 'light');
    }
  }, {
    node: direction === 'rtl' ? 'LTR' : 'RTL',
    id: 'direction',
    group: 'story',
    'aria-label': 'switch left to right/right to left',
    onClick: function onClick() {
      return setDirection(direction === 'rtl' ? 'ltr' : 'rtl');
    }
  }];
  var sourceActions = [];

  if (source && !story) {
    sourceActions.push({
      node: 'source',
      id: 'source',
      group: 'panels',
      'aria-label': 'display playground source code',
      panel: React.createElement(Source, {
        language: "javascript",
        dark: isDark
      }, source)
    });

    if (tab === undefined) {
      tab = 'source';
    }
  }

  var actionsItems = userScale ? [].concat(layoutActions, _toConsumableArray(zoomActions), sourceActions, _toConsumableArray(userActions)) : [].concat(layoutActions, sourceActions, _toConsumableArray(userActions));
  return React.createElement(StoryBlockContainer, {
    story: story,
    "data-testid": NAME$2,
    description: description,
    useStoryDescription: true,
    title: title,
    collapsible: collapsible
  }, React.createElement(PanelContainer, {
    plain: false,
    actions: actionsItems,
    openTab: tab,
    visibleTabs: visibleTabs,
    background: background,
    direction: direction
  }, React.createElement(Zoom, {
    scale: scale || 1
  }, React.createElement(PlaygroundContext.Provider, {
    value: {
      useDescription: true
    }
  }, wrapper ? React.createElement(Box, {
    variant: "playground.container"
  }, children) : children))));
};

var BaseStoryConfig = function BaseStoryConfig(_ref50) {
  var story = _ref50.story,
      doc = _ref50.doc,
      docPackage = _ref50.docPackage,
      sourceProps = _ref50.sourceProps;

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      showFileSource = _useState18[0],
      setShowFileSource = _useState18[1];

  var onShowFileSource = function onShowFileSource() {
    return setShowFileSource(!showFileSource);
  };

  var allActions = [];
  var repositoryItems = repositoryActions(docPackage);

  if (repositoryItems) {
    allActions.push.apply(allActions, _toConsumableArray(repositoryItems));
  }

  if (doc === null || doc === void 0 ? void 0 : doc.source) {
    allActions.push({
      node: showFileSource ? 'story code' : 'file code',
      onClick: onShowFileSource
    });
  }

  var _a = story || {},
      restStory = __rest(_a, ["loc", "renderFn", "source", "arguments"]);

  return Object.keys(restStory).length ? jsx(Source, Object.assign({
    language: "json"
  }, sourceProps, {
    actions: allActions
  }), JSON.stringify(restStory, null, 2)) : null;
};
/**
 * Displays the configuration object of a story.
 */


var StoryConfig = function StoryConfig(_a) {
  var id = _a.id,
      name = _a.name,
      sourceProps = _a.sourceProps,
      rest = __rest(_a, ["id", "name", "sourceProps"]);

  var story = useStory({
    id: id,
    name: name
  });
  var doc = useCurrentDocument();
  var docPackage = usePackage(doc === null || doc === void 0 ? void 0 : doc.package);
  return jsx(StoryBlockContainer, Object.assign({
    "data-testid": "story-config",
    story: story
  }, rest), jsx(BaseStoryConfig, {
    story: story,
    doc: doc,
    docPackage: docPackage,
    sourceProps: sourceProps
  }));
};

var getArgumentsLocations = function getArgumentsLocations() {
  var controls = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var args = arguments.length > 1 ? arguments[1] : undefined;
  return args ? args.reduce(function (acc, a, index) {
    if (Array.isArray(a.value)) {
      return [].concat(_toConsumableArray(acc), _toConsumableArray(getArgumentsLocations(a.name ? controls[a.name].value : controls, a.value)));
    }

    var locs = [];

    if (a.loc) {
      locs.push(Object.assign({
        type: 'loc'
      }, a.loc));
    }

    if (a.usage) {
      var usageLocs = a.usage.map(function (u) {
        return Object.assign(Object.assign({
          type: 'usage'
        }, u.loc), {
          shorthand: u.shorthand
        });
      });
      locs.push.apply(locs, _toConsumableArray(usageLocs));
    }

    return [].concat(_toConsumableArray(acc), [{
      name: a.value,
      controls: controls,
      index: index,
      locs: locs
    }]);
  }, []) : undefined;
};

var getTagColor = function getTagColor(tag, theme) {
  var colorIdx = tag.index % (theme.styles.length - 1);
  var style = theme.styles[colorIdx];
  return style.style.color || theme.plain.color || '#fff';
};

var findTagLocation = function findTagLocation(tags, token, line, column) {
  if (tags) {
    var _iterator = _createForOfIteratorHelper(tags),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var tag = _step.value;

        if (tag.name === token) {
          var loc = tag.locs.find(function (loc) {
            return loc.start.line === line && loc.start.column >= column && loc.start.column <= column + token.length;
          });

          if (loc) {
            return {
              name: tag.name,
              index: tag.index,
              controls: tag.controls,
              type: loc.type,
              shorthand: loc.shorthand
            };
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return undefined;
};

var tagToValue = function tagToValue(param, name) {
  var _a;

  var value = (_a = getControlValue(param.controls[name])) !== null && _a !== void 0 ? _a : getControlValues(param.controls);
  var retValue;

  if (Array.isArray(value) || typeof value === 'object') {
    retValue = stringifyObject(value, {
      indent: '  ',
      inlineCharacterLimit: 80
    });
  } else {
    retValue = value !== null && value !== void 0 ? value : name;
    retValue = typeof retValue === 'string' ? "\"".concat(retValue, "\"") : retValue.toString ? retValue.toString() : retValue;
  }

  return param.shorthand ? "".concat(param.name, ": ").concat(retValue) : retValue;
};
/* eslint-disable react/jsx-key */


var ViewStyleNext = {
  values: 'tags',
  tags: 'values'
};

var BaseStorySource = function BaseStorySource(_ref51) {
  var story = _ref51.story,
      doc = _ref51.doc,
      docPackage = _ref51.docPackage,
      sourceProps = _ref51.sourceProps,
      actions = _ref51.actions,
      _ref51$viewStyle = _ref51.viewStyle,
      initialViewStyle = _ref51$viewStyle === void 0 ? 'tags' : _ref51$viewStyle;

  var _useState19 = useState(initialViewStyle),
      _useState20 = _slicedToArray(_useState19, 2),
      viewStyle = _useState20[0],
      setViewStyle = _useState20[1];

  var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      showFileSource = _useState22[0],
      setShowFileSource = _useState22[1];

  var onMergeValues = function onMergeValues() {
    return setViewStyle(ViewStyleNext[viewStyle]);
  };

  var onShowFileSource = function onShowFileSource() {
    return setShowFileSource(!showFileSource);
  };

  var _ref52 = story || {},
      controls = _ref52.controls;

  var allActions = [];
  var repositoryItems = repositoryActions(docPackage);

  if (repositoryItems) {
    allActions.push.apply(allActions, _toConsumableArray(repositoryItems));
  }

  if (doc === null || doc === void 0 ? void 0 : doc.source) {
    allActions.push({
      node: showFileSource ? 'story code' : 'file code',
      onClick: onShowFileSource
    });
  }

  var args = story === null || story === void 0 ? void 0 : story.arguments;
  var tags = getArgumentsLocations(controls, args);

  if (args && args.length) {
    if (!showFileSource) {
      allActions.push({
        node: ViewStyleNext[viewStyle],
        onClick: onMergeValues
      });
    }
  }

  if (actions) {
    allActions.push.apply(allActions, _toConsumableArray(actions));
  }

  var source;

  if (!showFileSource) {
    source = (story === null || story === void 0 ? void 0 : story.source) || '';
  } else {
    source = (doc === null || doc === void 0 ? void 0 : doc.source) || '';
  }

  return jsx(Source, Object.assign({
    actions: allActions
  }, sourceProps, {
    renderFn: function renderFn(_ref53, _ref54) {
      var className = _ref53.className,
          style = _ref53.style,
          tokens = _ref53.tokens,
          getLineProps = _ref53.getLineProps,
          getTokenProps = _ref53.getTokenProps;
      var theme = _ref54.theme;
      return jsx(Themed.pre, {
        className: "".concat(className),
        style: Object.assign(Object.assign({}, style), {
          padding: '25px 10px 10px',
          margin: 0
        })
      }, tokens.map(function (line, i) {
        return jsx("div", Object.assign({}, getLineProps({
          line: line,
          key: i
        })), function () {
          var column = 0;
          return line.map(function (token, key) {
            var tokenTrim = token.content.trim();
            var param = tags ? findTagLocation(tags, tokenTrim, i, column) : null;
            column += token.content.length;

            if (param) {
              var color = getTagColor(param, theme);
              var splitToken = getTokenProps({
                token: token,
                key: key
              }).children.split(/(\s+)/);
              return splitToken.map(function (tokenName) {
                return tokenName.trim().length ? jsx(Tag, Object.assign({}, getTokenProps({
                  token: token,
                  key: key
                }), {
                  color: color
                }), viewStyle === 'values' && param.type === 'usage' ? tagToValue(param, tokenName) : tokenName) : tokenName;
              });
            }

            return jsx("span", Object.assign({}, getTokenProps({
              token: token,
              key: key
            }), {
              sx: {
                display: 'inline-block'
              }
            }));
          });
        }());
      }));
    }
  }), source.trim());
};
/**
 * Display source code of a story.
 * If controls are used, all story arguments will be highlighted.
 * Additional commands are made available if the repository data of the story is available.
 */


var StorySource = function StorySource(_a) {
  var viewStyle = _a.viewStyle,
      id = _a.id,
      name = _a.name,
      sourceProps = _a.sourceProps,
      rest = __rest(_a, ["viewStyle", "id", "name", "sourceProps"]);

  var story = useStory({
    id: id,
    name: name
  });
  var doc = useCurrentDocument();
  var docPackage = usePackage(doc === null || doc === void 0 ? void 0 : doc.package);
  return React.createElement(StoryBlockContainer, Object.assign({
    story: story,
    "data-testid": "story-source"
  }, rest), React.createElement(BaseStorySource, {
    story: story,
    doc: doc,
    docPackage: docPackage,
    sourceProps: sourceProps,
    viewStyle: viewStyle
  }));
};

var StoryPlayground = function StoryPlayground(_a) {
  var dark = _a.dark,
      id = _a.id,
      _a$actions = _a.actions,
      actions = _a$actions === void 0 ? [] : _a$actions,
      storyProps = _a.storyProps,
      props = __rest(_a, ["dark", "id", "actions", "storyProps"]);

  var theme = useTheme$1();
  var storyId = useStoryIdFromName(storyProps.name) || id || storyProps.id;
  var story = useStory({
    id: storyId
  });

  if (!story) {
    return null;
  }

  var isDark = dark === undefined ? theme.initialColorModeName === 'dark' : dark;
  var storyActions = [];
  storyActions.push({
    node: 'source',
    id: 'source',
    group: 'panels',
    'aria-label': 'display story source code',
    panel: React.createElement(StorySource, {
      sourceProps: {
        dark: isDark
      },
      sx: {
        mt: 0,
        mb: 0
      },
      id: storyId
    })
  });
  storyActions.push({
    node: 'config',
    id: 'config',
    group: 'panels',
    'aria-label': 'display story configuration object',
    panel: React.createElement(StoryConfig, {
      sourceProps: {
        dark: isDark
      },
      sx: {
        mt: 0,
        mb: 0
      },
      id: storyId
    })
  });
  return React.createElement(BasePlayground, Object.assign({
    wrapper: false,
    story: story,
    isDark: isDark,
    actions: [].concat(_toConsumableArray(actions), storyActions)
  }, props));
};
/**
 * Component to display a live playground of component examples. Has custom actions for zooming, switch direction, review story source and configuration.
 */


var Playground = function Playground(props) {
  var children = props.children,
      rest = __rest(props, ["children"]);

  var childArr = Children.toArray(children);

  if (childArr.length === 1) {
    var child = childArr[0];

    if (child.type.displayName === 'Story') {
      return React.createElement(StoryPlayground, Object.assign({
        storyProps: child.props
      }, props));
    }
  }

  return React.createElement(BasePlayground, Object.assign({}, rest), typeof children === 'function' ? children() : children);
};
/**
 * error message when the control type is not found.
 */


var InvalidType = function InvalidType() {
  return React.createElement("span", null, "Invalid Type");
};

var useControlsActions = function useControlsActions(props) {
  var controls = props.controls,
      setControlValue = props.setControlValue,
      storyId = props.storyId;

  var _useState23 = useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      copied = _useState24[0],
      setCopied = _useState24[1];

  var _useState25 = useState(false),
      _useState26 = _slicedToArray(_useState25, 2),
      urlCopied = _useState26[0],
      setURLCopied = _useState26[1];

  var _useMemo = useMemo(function () {
    var keys = controls ? Object.keys(controls) : [];
    var canRandomize = controls && keys.some(function (key) {
      var control = controls[key];
      return canRandomizeControl(control);
    });
    var canReset = controls && keys.some(function (key) {
      var control = controls[key];
      return canResetControl(control);
    });
    return {
      hasControls: keys.length,
      canRandomize: canRandomize,
      canReset: canReset
    };
  }, [controls]),
      hasControls = _useMemo.hasControls,
      canReset = _useMemo.canReset,
      canRandomize = _useMemo.canRandomize;

  if (!hasControls) {
    return [];
  }

  var onReset = function onReset(e) {
    e.preventDefault();

    if (setControlValue && storyId && controls) {
      var values = resetControlValues(controls);
      setControlValue(storyId, undefined, values);
    }
  };

  var onCopy = function onCopy(e) {
    e.preventDefault();
    var values = getControlValues(controls);
    copy(JSON.stringify(values, null, 2));

    if (typeof window$1 !== 'undefined') {
      setCopied(true);
      window$1.setTimeout(function () {
        return setCopied(false);
      }, 1500);
    }
  };

  var actions = [{
    node: copied ? 'values copied' : 'copy values',
    onClick: onCopy,
    group: 'controls',
    id: 'copy_controls',
    'aria-label': 'copy control values'
  }];

  if (canRandomize) {
    actions.push({
      node: 'randomize',
      group: 'controls',
      onClick: function onClick() {
        if (setControlValue && controls && storyId) {
          setControlValue(storyId, undefined, randomizeData(controls));
        }
      },
      id: 'randomize',
      'aria-label': 'generate random values for the component controls'
    });
    actions.push({
      node: urlCopied ? 'url copied' : 'share',
      group: 'controls',
      onClick: function onClick() {
        if (controls) {
          var url = getURL();

          if (url) {
            var parsedParams = queryString.parse(url.search);
            var values = getControlValues(controls);
            parsedParams.controls = JSON.stringify(values);
            var strValues = queryString.stringify(parsedParams);
            var copyURL = "".concat(url.protocol, "//").concat(url.host).concat(url.pathname).concat(strValues ? "?".concat(strValues) : '').concat(url.hash ? "#".concat(url.hash) : '');
            copy(copyURL);

            if (typeof window$1 !== 'undefined') {
              setURLCopied(true);
              window$1.setTimeout(function () {
                return setURLCopied(false);
              }, 1500);
            }
          }
        }
      },
      id: 'share_controls',
      'aria-label': 'copy the control values as url search params'
    });
  }

  if (canReset) {
    actions.push({
      node: 'reset',
      onClick: onReset,
      group: 'controls',
      id: 'reset',
      'aria-label': 'reset control values to their initial value'
    });
  }

  return actions;
};
/* eslint-disable react/display-name */


var BasePropsTable = function BasePropsTable(_ref55) {
  var _ref55$component = _ref55.component,
      component = _ref55$component === void 0 ? {} : _ref55$component,
      extraColumns = _ref55.extraColumns,
      tableProps = _ref55.tableProps,
      visibility = _ref55.visibility,
      flat = _ref55.flat;

  var _useState27 = useState(false),
      _useState28 = _slicedToArray(_useState27, 2),
      copied = _useState28[0],
      setCopied = _useState28[1];

  var story = useCurrentStory();
  var info = useMemo(function () {
    return component.info || {};
  }, [component]);

  var _useControl = useControl(),
      _useControl2 = _slicedToArray(_useControl, 2),
      _setControlValue = _useControl2[1];

  var controls = useMemo(function () {
    var storyControls = visibility !== 'info' ? (story === null || story === void 0 ? void 0 : story.controls) || {} : {};
    return visibleControls(storyControls, story);
  }, [visibility, story]);
  var infoKeys = useMemo(function () {
    return info && info.props ? Object.keys(info.props) : [];
  }, [info]); // check if we should display controls in the PrpsTable
  // at least one control's name should exist as a property name

  var _useMemo2 = useMemo(function () {
    return {
      hasControls: !!Object.keys(controls).length,
      propControls: Object.assign({}, controls)
    };
  }, [controls]),
      hasControls = _useMemo2.hasControls,
      propControls = _useMemo2.propControls;

  var _useMemo3 = useMemo(function () {
    var parents = new Set();
    var rows = infoKeys.map(function (key) {
      var prop = info.props[key];
      var control = propControls[key];
      var parentName = (control === null || control === void 0 ? void 0 : control.groupId) || prop && prop.parentName || '-';

      var _ref56 = control || {},
          description = _ref56.description,
          label = _ref56.label,
          required = _ref56.required;

      if (control) {
        delete propControls[key];
      } else if (visibility === 'controls') {
        return null;
      }

      parents.add(parentName);
      return {
        name: key,
        prop: Object.assign(Object.assign({}, prop), {
          type: Object.assign({
            label: label,
            required: required
          }, prop === null || prop === void 0 ? void 0 : prop.type),
          description: description !== null && description !== void 0 ? description : prop === null || prop === void 0 ? void 0 : prop.description,
          parentName: parentName
        }),
        control: control
      };
    }).filter(function (p) {
      return p;
    });

    if (propControls) {
      var controlsRows = [];
      Object.keys(propControls).forEach(function (key) {
        var control = propControls[key];

        if (!control.hidden) {
          var parentName = control.groupId || '-';
          parents.add(parentName);
          controlsRows.push({
            name: key,
            prop: {
              description: control.description,
              parentName: parentName,
              defaultValue: control.defaultValue,
              type: {
                name: control.type,
                required: control.required
              }
            },
            control: control
          });
        }
      });
      rows = [].concat(controlsRows, _toConsumableArray(rows));
    }

    var groupProps = {};

    if (parents.size > 1 && !flat) {
      var firstRowWithParent = rows.find(function (row) {
        return row === null || row === void 0 ? void 0 : row.prop.parentName;
      });

      if (firstRowWithParent) {
        groupProps.expanded = _defineProperty({}, "prop.parentName:".concat(firstRowWithParent.prop.parentName), true);
      }

      groupProps.groupBy = ['prop.parentName'];
    } else {
      groupProps.hiddenColumns = ['prop.parentName'];
    }

    var columns = [{
      Header: 'Parent',
      accessor: 'prop.parentName'
    }, {
      Header: 'Name',
      width: 150,
      accessor: 'name',
      Cell: function Cell(_ref57) {
        var original = _ref57.row.original;

        if (!original) {
          return null;
        }

        var name = original.name,
            _original$prop = original.prop,
            required = _original$prop.type.required,
            deprecated = _original$prop.deprecated,
            control = original.control;
        var text = jsx(Text, {
          title: deprecated ? "deprecated: ".concat(deprecated) : undefined,
          variant: deprecated ? 'propstable.name-deprecated' : 'propstable.name'
        }, control ? control.label || name : name);
        return required ? jsx(Tag, {
          color: "red",
          transparentAmount: 0.95,
          borderSize: 1
        }, text) : text;
      }
    }, {
      Header: 'Description',
      accessor: 'prop.description',
      Cell: function Cell(_ref58) {
        var original = _ref58.row.original;

        if (!original) {
          return null;
        }

        var name = original.name,
            _original$prop2 = original.prop,
            description = _original$prop2.description,
            _original$prop2$type = _original$prop2.type,
            raw = _original$prop2$type.raw,
            typeName = _original$prop2$type.name,
            value = _original$prop2$type.value;
        return jsx(Box, {
          variant: "propstable.description.container"
        }, description && jsx(Markdown, null, description), (raw !== null && raw !== void 0 ? raw : typeName) && jsx(Box, {
          variant: "propstable.description.type"
        }, jsx(Themed.pre, null, Array.isArray(value) && value.length > 1 ? value.filter(function (_ref59) {
          var value = _ref59.value;
          return value !== 'undefined';
        }).map(function (_ref60) {
          var typeName = _ref60.name,
              value = _ref60.value;
          return jsx(Tag, {
            key: "".concat(name, "_").concat(value || typeName),
            color: "grey",
            transparentAmount: 0.9,
            borderSize: 1,
            variant: "tag.rightmargin"
          }, value || typeName);
        }) : raw !== null && raw !== void 0 ? raw : typeName)));
      }
    }, {
      Header: 'Default',
      accessor: 'prop.defaultValue',
      Cell: function Cell(_ref61) {
        var original = _ref61.row.original;

        if (!original) {
          return null;
        }

        var defaultValue = original.prop.defaultValue;
        var value = null;

        switch (typeof defaultValue) {
          case 'object':
            value = JSON.stringify(defaultValue, null, 2);
            break;

          case 'undefined':
            value = '-';
            break;

          default:
            value = defaultValue.toString();
        }

        return jsx(Box, {
          variant: "propstable.defaultvalue"
        }, jsx(Themed.pre, null, value));
      }
    }].concat(_toConsumableArray(extraColumns));

    if (hasControls) {
      columns.push({
        Header: 'Controls',
        accessor: 'control',
        Cell: function Cell(_ref62) {
          var original = _ref62.row.original;
          var control = original.control;

          if (control) {
            var InputType = getPropertyEditor(control.type) || InvalidType;
            return jsx(Box, {
              variant: "propstable.control"
            }, jsx(InputType, {
              name: original.name
            }));
          }

          return null;
        }
      });
    }

    return {
      columns: columns,
      rows: rows,
      groupProps: groupProps
    };
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [hasControls, info.props, story === null || story === void 0 ? void 0 : story.id, visibility]),
      columns = _useMemo3.columns,
      rows = _useMemo3.rows,
      groupProps = _useMemo3.groupProps;

  var table = jsx(Table, Object.assign({}, groupProps, tableProps, {
    columns: columns,
    data: rows,
    sx: {
      th: {
        //some space for the action bar
        pt: 4
      }
    }
  }));
  var actions = [];

  var onCopy = function onCopy(e) {
    var quotedValue = function quotedValue(value) {
      return "\"".concat(jsStringEscape(value), "\"");
    };

    e.preventDefault();
    var csvRows = rows.map(function (rowOrNull) {
      var _a, _b, _c, _d, _e;

      var row = rowOrNull;
      var r = [quotedValue(row.name), quotedValue((_a = row.prop.type.raw) !== null && _a !== void 0 ? _a : row.prop.type.name), quotedValue((_b = row.prop.defaultValue) !== null && _b !== void 0 ? _b : ''), quotedValue((_c = row.prop.description) !== null && _c !== void 0 ? _c : '')];

      if (hasControls) {
        var value = (_d = row.control) === null || _d === void 0 ? void 0 : _d.value;

        if (Array.isArray(value) || typeof value === 'object') {
          r.push(quotedValue(JSON.stringify(value)));
        } else {
          r.push(quotedValue((_e = value) !== null && _e !== void 0 ? _e : ''));
        }
      }

      return r.join(',');
    }).join('\n');
    copy(csvRows);

    if (typeof window$1 !== 'undefined') {
      setCopied(true);
      window$1.setTimeout(function () {
        return setCopied(false);
      }, 1500);
    }
  };

  actions.push({
    node: copied ? 'copied' : 'copy table',
    onClick: onCopy,
    id: 'copy_table',
    'aria-label': 'copy table as csv'
  });
  actions.push.apply(actions, _toConsumableArray(useControlsActions({
    controls: controls,
    storyId: story === null || story === void 0 ? void 0 : story.id,
    setControlValue: function setControlValue(storyId, propertyName, value) {
      _setControlValue(value);
    }
  })));
  return jsx(ActionContainer, {
    actions: actions
  }, table);
};

var NAME$3 = 'propstable';
/**
 * Displays the component's properties as well as configurable controls to interact with the component.
 */

var PropsTable = function PropsTable(props) {
  var custom = useCustomProps(NAME$3, props);

  var _custom$extraColumns = custom.extraColumns,
      extraColumns = _custom$extraColumns === void 0 ? [] : _custom$extraColumns,
      _custom$visibility = custom.visibility,
      visibility = _custom$visibility === void 0 ? 'all' : _custom$visibility,
      flat = custom.flat,
      rest = __rest(custom, ["extraColumns", "visibility", "flat"]);

  return jsx(ComponentsBlockContainer, Object.assign({
    "data-testid": NAME$3,
    visibility: visibility
  }, rest), function (component, tableProps, story) {
    var table = jsx(BasePropsTable, {
      component: component,
      visibility: visibility,
      extraColumns: extraColumns,
      tableProps: tableProps,
      flat: flat
    });
    return story ? jsx(StoryContextProvider, {
      storyId: story.id
    }, jsx(ControlsContextStoryProvider, null, table)) : table;
  });
};
/** @jsx jsx */

/**
 * search input component connected to the store
 */


var Search = function Search(props) {
  var searchHook = useSearch();

  var onSelectItem = function onSelectItem(item) {
    window.location.href = item.link;
  };

  if (!searchHook) {
    return null;
  }

  var items = searchHook.items,
      searchFn = searchHook.searchFn,
      provider = searchHook.provider;
  return jsx(SearchInput, Object.assign({
    "aria-label": "full text search",
    onSearch: searchFn,
    items: items,
    onSelect: onSelectItem,
    placeholder: "search...",
    render: provider ? function (rendered) {
      return jsx(Box, {
        sx: {
          display: 'flex',
          flexDirection: 'column'
        }
      }, rendered, jsx(Box, {
        sx: {
          p: 2,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center'
        }
      }, jsx(Text, {
        sx: {
          mr: 1
        }
      }, "Search by"), jsx(Link$1, {
        sx: {
          display: 'flex'
        },
        href: provider.url,
        target: "_blank",
        "aria-label": provider.name,
        rel: "noopener noreferrer"
      }, provider.logo)));
    } : undefined
  }, props), function (props) {
    return jsx(DocumentItem, {
      sx: {
        borderBottom: function borderBottom(t) {
          var _a;

          return " 1px solid  ".concat((_a = t.colors) === null || _a === void 0 ? void 0 : _a.shadow);
        }
      },
      item: props.item
    });
  });
};

var IframeWrapper = function IframeWrapper(_ref63) {
  var children = _ref63.children,
      title = _ref63.title,
      _ref63$style = _ref63.style,
      style = _ref63$style === void 0 ? {
    border: 0
  } : _ref63$style,
      _ref63$initialIframeC = _ref63.initialIframeContent,
      initialIframeContent = _ref63$initialIframeC === void 0 ? "\n<!DOCTYPE html>\n<html lang=\"eng\">\n  <head>\n    <style>\n      body {\n        margin: 0;\n      }\n    </style>\n  </head>\n  <body>\n    <div>\n    </div>\n  </body>\n</html>\n" : _ref63$initialIframeC;

  var _useState29 = useState(),
      _useState30 = _slicedToArray(_useState29, 2),
      size = _useState30[0],
      setSize = _useState30[1];

  return jsx(Iframe, {
    initialContent: initialIframeContent,
    title: title,
    style: Object.assign(Object.assign({}, style), {
      height: size === null || size === void 0 ? void 0 : size.height,
      width: '100%'
    })
  }, jsx(ReactResizeDetector, {
    handleHeight: true,
    onResize: function onResize(width, height) {
      setSize({
        width: width,
        height: height
      });
    }
  }, children));
};

var StoryWrapper = function StoryWrapper(_ref64) {
  var _ref64$wrapper = _ref64.wrapper,
      wrapper = _ref64$wrapper === void 0 ? 'wrapper' : _ref64$wrapper,
      iframeStyle = _ref64.iframeStyle,
      children = _ref64.children,
      title = _ref64.title;

  switch (wrapper) {
    case 'iframe':
      return jsx(IframeWrapper, {
        title: title,
        style: iframeStyle
      }, children);

    default:
      return jsx(Fragment, null, children);
  }
};

var NAME$4 = 'story';
var StoryRender = forwardRef(function StoryRender(_a, ref) {
  var story = _a.story,
      wrapper = _a.wrapper,
      iframeStyle = _a.iframeStyle,
      rest = __rest(_a, ["story", "wrapper", "iframeStyle"]);

  var store = useStore();
  var options = useExternalOptions();
  var rendered = store.config.renderFn ? store.config.renderFn({
    story: story,
    doc: story.doc ? store.docs[story.doc] : undefined,
    options: options
  }) : null;
  return jsx(Box, Object.assign({
    "data-testid": NAME$4,
    id: story.id,
    variant: "".concat(NAME$4, ".container")
  }, rest), jsx(StoryWrapper, {
    title: story.name,
    iframeStyle: iframeStyle,
    wrapper: wrapper
  }, jsx(Box, {
    className: "story-render-container",
    variant: "".concat(NAME$4, ".wrapper"),
    ref: ref
  }, rendered)));
});
StoryRender.displayName = 'StoryRender';
/**
 * block component to render story function with decorators
 */

var Story = forwardRef(function Story(fullProps, ref) {
  var custom = useCustomProps(NAME$4, fullProps);

  var wrapper = custom.wrapper,
      onRender = custom.onRender,
      iframeStyle = custom.iframeStyle,
      props = __rest(custom, ["wrapper", "onRender", "iframeStyle"]);

  useEffect(function () {
    return onRender && onRender();
  });

  var id = props.id,
      name = props.name,
      rest = __rest(props, ["id", "name"]);

  var story = useStory({
    id: id,
    name: name
  });

  if (story && story.id && story.renderFn) {
    return jsx(StoryBlockContainer, Object.assign({}, rest, {
      "data-testid": "story",
      story: story
    }), jsx(StoryRender, {
      ref: ref,
      story: story,
      iframeStyle: iframeStyle,
      wrapper: wrapper
    }));
  } else {
    console.error('Story function not found');
    return null;
  }
});
Story.displayName = 'Story';
/**
 * displays multiple stories in ther own Playground components
 *
 */

var Stories = function Stories(_a) {
  var id = _a.id,
      name = _a.name,
      title = _a.title,
      rest = __rest(_a, ["id", "name", "title"]);

  var story = useStory({
    id: id,
    name: name
  });
  var doc = useDocument(story === null || story === void 0 ? void 0 : story.doc);
  var store = useStore();
  var stories = (doc === null || doc === void 0 ? void 0 : doc.stories) ? doc.stories.filter(function (id) {
    return !story || story.id !== id;
  }) : [];

  if (!stories || !stories.length) {
    return null;
  }

  return React.createElement(StoryBlockContainer, Object.assign({
    story: story,
    title: title,
    "data-testid": "stories"
  }, rest), stories.map(function (id) {
    var story = store.stories[id];
    return React.createElement(StoryPlayground, Object.assign({
      title: story.name,
      id: id,
      collapsible: false,
      key: "playground-".concat(id),
      storyProps: {
        id: id
      }
    }, rest), React.createElement(Story, {
      id: id
    }));
  }));
};

Stories.defaultProps = {
  title: 'Stories'
};
var layoutProps = {};
var MDXLayout = 'wrapper'; //@ts-ignore

var MDXContent = function MDXContent(_a) {
  var components = _a.components,
      props = __rest(_a, ["components"]);

  return (//@ts-ignore
    React.createElement(MDXLayout, Object.assign({}, layoutProps, props, {
      components: components
    }), React.createElement("h1", null, "Smart controls"))
  );
}; //@ts-ignore


MDXContent.isMDXComponent = true;
var img = "data:image/jpeg;base64,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";

var _a;

var store = Object.assign(Object.assign({}, getDefaultStore()), {
  search: require('@component-controls/search-fusejs').default,
  config: Object.assign(Object.assign({}, deepMerge(defaultBuildConfig, defaultRunConfig)), {
    renderFn: render,
    pages: Object.assign(Object.assign({}, defaultBuildConfig.pages), {
      story: Object.assign(Object.assign({}, (_a = defaultBuildConfig.pages) === null || _a === void 0 ? void 0 : _a.story), {
        tabs: {
          page: ClassicPage
        }
      })
    })
  }),
  packages: {
    'test-package': {
      fileHash: '28feb04b2447384a0bd648387e62bbc7',
      name: '@component-controls/blocks',
      version: '1.0.3',
      repository: {
        browse: 'https://github.com/ccontrols/component-controls/tree/master/ui/blocks/src/Title/Title.stories.tsx',
        docs: 'https://github.com/ccontrols/component-controls/tree/master#readme',
        issues: 'https://github.com/ccontrols/component-controls/issues'
      },
      dependencies: {
        '@component-controls/components': '^1.0.1',
        '@component-controls/core': '^1.0.1',
        '@component-controls/editors': '^1.0.1',
        '@component-controls/store': '^1.0.3',
        '@mdx-js/react': '^1.6.5',
        '@primer/octicons-react': '^10.0.0',
        'copy-to-clipboard': '^3.2.1',
        global: '^4.3.2',
        'js-string-escape': '^1.0.1',
        react: '^16.13.1',
        'react-dom': '^16.13.1',
        'react-table': '^7.0.0',
        'stringify-object': '^3.3.0',
        'theme-ui': '^0.3.1'
      },
      devDependencies: {
        '@theme-ui/presets': '^0.6.0-alpha.7',
        '@types/jest': '^26.0.10',
        '@types/mdx-js__react': '^1.5.1',
        '@types/stringify-object': '^3.2.0',
        '@types/theme-ui': '^0.3.0',
        'cross-env': '^5.2.1',
        eslint: '^6.5.1',
        jest: '^26.4.2'
      },
      peerDependencies: {
        '@primer/octicons-react': '*',
        react: '^16.13.1',
        'react-dom': '^16.13.1',
        'react-table': '*',
        'theme-ui': '*'
      }
    }
  },
  components: {
    ArrowButton: {
      from: '../../components/button-default-arrow-func',
      importedName: 'default',
      name: 'ArrowButton',
      jsx: [{
        from: './Button',
        name: 'Button',
        componentKey: 'Button',
        importedName: 'Button',
        attributes: ['ref', 'id']
      }],
      externalDependencies: {
        react: [{
          name: 'React',
          importedName: 'default'
        }, {
          name: 'FC',
          importedName: 'FC'
        }],
        '@component-controls/components': [{
          name: 'Table',
          importedName: 'Table'
        }]
      },
      localDependencies: {
        './Button': [{
          name: 'Button',
          importedName: 'Button'
        }, {
          name: 'ButtonProps',
          importedName: 'ButtonProps'
        }],
        '@component-controls/components': [{
          name: 'Table',
          importedName: 'Table'
        }]
      },
      package: 'test-package'
    },
    Button: {
      from: '../../components/button-named-arrow-func',
      importedName: 'Button',
      name: 'Button',
      info: {
        description: "\nMarkdown descripton for component.\n# With a heading\nand some bold **text**\n        ",
        displayName: 'typescript',
        props: {
          optionalArray: {
            parentName: 'MyComponentProps',
            type: {
              name: 'array',
              raw: 'any[]',
              value: [{
                name: 'any'
              }]
            }
          },
          optionalArrayOf: {
            parentName: 'MyComponentProps',
            type: {
              name: 'array',
              raw: 'number[]',
              value: [{
                name: 'number'
              }]
            }
          },
          optionalBool: {
            parentName: 'MyComponentProps',
            type: {
              name: 'boolean',
              raw: 'boolean'
            }
          },
          optionalElement: {
            parentName: 'MyComponentProps',
            type: {
              name: 'any',
              raw: 'any'
            }
          },
          optionalElementType: {
            parentName: 'MyComponentProps',
            type: {
              name: 'Element',
              raw: 'Element'
            }
          },
          optionalEnum: {
            parentName: 'MyComponentProps',
            type: {
              name: 'enum',
              raw: '"News" | "Photos"',
              value: [{
                name: 'string',
                value: 'News'
              }, {
                name: 'string',
                value: 'Photos'
              }]
            }
          },
          optionalFunc: {
            parentName: 'MyComponentProps',
            type: {
              name: 'function',
              raw: '(args: any) => any'
            }
          },
          optionalMessage: {
            parentName: 'MyComponentProps',
            type: {
              name: 'Message',
              raw: 'Message'
            }
          },
          optionalNode: {
            parentName: 'MyComponentProps',
            type: {
              name: 'any',
              raw: 'any'
            }
          },
          optionalNumber: {
            defaultValue: 21,
            parentName: 'MyComponentProps',
            type: {
              name: 'number',
              raw: 'number'
            }
          },
          optionalObject: {
            parentName: 'MyComponentProps',
            type: {
              name: 'object',
              raw: 'object'
            }
          },
          optionalObjectOf: {
            parentName: 'MyComponentProps',
            type: {
              name: 'object',
              raw: '{ [key: string]: number; }'
            }
          },
          optionalObjectWithShape: {
            parentName: 'MyComponentProps',
            type: {
              name: 'object',
              raw: '{ optionalProperty?: string; requiredProperty: number; }'
            }
          },
          optionalObjectWithStrictShape: {
            parentName: 'MyComponentProps',
            type: {
              name: 'object',
              raw: '{ optionalProperty?: string; requiredProperty: number; }'
            }
          },
          optionalString: {
            parentName: 'MyComponentProps',
            type: {
              name: 'string',
              raw: 'string'
            }
          },
          optionalSymbol: {
            parentName: 'MyComponentProps',
            type: {
              name: 'symbol',
              raw: 'symbol'
            }
          },
          optionalUnion: {
            parentName: 'MyComponentProps',
            type: {
              name: 'union',
              raw: 'string | number | Message',
              value: [{
                name: 'string'
              }, {
                name: 'number'
              }, {
                name: 'Message'
              }]
            }
          },
          requiredAny: {
            parentName: 'MyComponentProps',
            type: {
              name: 'any',
              raw: 'any',
              required: true
            }
          },
          requiredFunc: {
            parentName: 'MyComponentProps',
            type: {
              name: 'function',
              raw: '(prop: any) => any',
              required: true
            }
          }
        }
      }
    },
    Control: {
      from: '../../components/button-named-arrow-func',
      importedName: 'Button',
      name: 'Button',
      fileInfo: {
        sloc: {
          total: 28,
          source: 25,
          comment: 1,
          single: 0,
          block: 1,
          mixed: 0,
          empty: 2,
          todo: 5,
          blockEmpty: 0
        },
        commits: [{
          committerName: 'martin-stoyanov',
          authorName: 'martin-stoyanov',
          authorDate: '2021-02-23T22:48:26.000Z',
          subject: 'third commit'
        }, {
          committerName: 'martin-stoyanov',
          authorName: 'martin-stoyanov',
          authorDate: '2021-02-22T22:48:26.000Z',
          subject: '(งツ)ว'
        }, {
          committerName: 'atanasster',
          authorName: 'atanasster',
          authorDate: '2021-02-21T22:48:26.000Z',
          subject: 'first commit!'
        }, {
          committerName: 'atanasster',
          authorName: 'atanasster',
          authorDate: '2021-02-21T22:48:26.000Z',
          subject: 'first commit!'
        }, {
          committerName: 'martin-stoyanov',
          authorName: 'martin-stoyanov',
          authorDate: '2021-02-21T22:48:26.000Z',
          subject: 'first commit!'
        }, {
          committerName: 'atanasster',
          authorName: 'atanasster',
          authorDate: '2021-02-21T22:48:26.000Z',
          subject: 'first commit!'
        }, {
          committerName: 'atanasster',
          authorName: 'atanasster',
          authorDate: '2021-02-21T22:48:26.000Z',
          subject: 'first commit!'
        }, {
          committerName: 'atanasster',
          authorName: 'atanasster',
          authorDate: '2021-02-21T22:48:26.000Z',
          subject: 'first commit!'
        }, {
          committerName: 'atanasster',
          authorName: 'atanasster',
          authorDate: '2021-02-21T22:48:26.000Z',
          subject: 'first commit!'
        }, {
          committerName: 'atanasster',
          authorName: 'atanasster',
          authorDate: '2021-02-21T22:48:26.000Z',
          subject: 'first commit!'
        }, {
          committerName: 'atanasster',
          authorName: 'atanasster',
          authorDate: '2021-02-21T22:48:26.000Z',
          subject: 'first commit!'
        }, {
          committerName: 'atanasster',
          authorName: 'atanasster',
          authorDate: '2021-02-21T22:48:26.000Z',
          subject: 'first commit!'
        }]
      },
      jest: {
        results: [{
          leaks: false,
          perfStats: {
            end: 1618979220883,
            runtime: 5950,
            slow: true,
            start: 1618979214933
          },
          testFilePath: 'Table.test.ts',
          testResults: [{
            ancestorTitles: ['Table'],
            duration: 196,
            failureDetails: [],
            fullName: 'Table overview',
            numPassingAsserts: 0,
            status: 'passed',
            title: 'overview'
          }, {
            ancestorTitles: ['Table'],
            duration: 91,
            failureDetails: [],
            fullName: 'Table noHeader',
            numPassingAsserts: 0,
            status: 'passed',
            title: 'noHeader'
          }, {
            ancestorTitles: ['Table'],
            duration: 33,
            failureDetails: [{
              message: "\x1B[2mexpect(\x1B[22m\x1B[38;2;0;95;95m\x1B[48;2;215;255;255mreceived\x1B[49m\x1B[39m\x1B[2m).\x1B[22mtoMatchSnapshot\x1B[2m()\x1B[22m\n\nSnapshot name: `Table editing 1`\n\n\x1B[38;2;128;0;128m\x1B[48;2;255;215;255m- Snapshot  - 1\x1B[49m\x1B[39m\n\x1B[38;2;0;95;95m\x1B[48;2;215;255;255m+ Received  + 1\x1B[49m\x1B[39m\n\n\x1B[33m@@ -40,11 +40,11 @@\x1B[39m\n\x1B[2m            class=\"css-l4u9co\"\x1B[22m\n\x1B[2m            role=\"cell\"\x1B[22m\n\x1B[2m            style=\"width: 150px;\"\x1B[22m\n\x1B[2m          >\x1B[22m\n\x1B[2m            <input\x1B[22m\n\x1B[38;2;128;0;128m\x1B[48;2;255;215;255m-             value=\"sample\"\x1B[49m\x1B[39m\n\x1B[38;2;0;95;95m\x1B[48;2;215;255;255m+             value=\"example\"\x1B[49m\x1B[39m\n\x1B[2m            />\x1B[22m\n\x1B[2m          </td>\x1B[22m\n\x1B[2m        </tr>\x1B[22m\n\x1B[2m      </tbody>\x1B[22m\n\x1B[2m    </table>\x1B[22m"
            }],
            fullName: 'Table editing',
            numPassingAsserts: 0,
            status: 'failed',
            title: 'editing'
          }, {
            ancestorTitles: ['Table'],
            duration: 33,
            failureDetails: [],
            fullName: 'Table disable',
            numPassingAsserts: 0,
            status: 'disabled',
            title: 'disable'
          }, {
            ancestorTitles: ['Table'],
            duration: 33,
            failureDetails: [],
            fullName: 'Table pending',
            numPassingAsserts: 0,
            status: 'pending',
            title: 'pending'
          }, {
            ancestorTitles: ['Table'],
            duration: 33,
            failureDetails: [],
            fullName: 'Table skipped',
            numPassingAsserts: 0,
            status: 'skipped',
            title: 'skipped'
          }, {
            ancestorTitles: ['Table'],
            duration: 33,
            failureDetails: [],
            fullName: 'Table todo',
            numPassingAsserts: 0,
            status: 'todo',
            title: 'todo'
          }, {
            ancestorTitles: ['Table'],
            duration: 144,
            failureDetails: [],
            fullName: 'Table rowSelect',
            numPassingAsserts: 0,
            status: 'passed',
            title: 'rowSelect'
          }, {
            ancestorTitles: ['Table'],
            duration: 169,
            failureDetails: [],
            fullName: 'Table pagination',
            numPassingAsserts: 0,
            status: 'passed',
            title: 'pagination'
          }, {
            ancestorTitles: ['Table'],
            duration: 115,
            failureDetails: [],
            fullName: 'Table sortable',
            numPassingAsserts: 0,
            status: 'passed',
            title: 'sortable'
          }, {
            ancestorTitles: ['Table'],
            duration: 115,
            failureDetails: [],
            fullName: 'Table filterable',
            numPassingAsserts: 0,
            status: 'passed',
            title: 'filterable'
          }, {
            ancestorTitles: ['Table'],
            duration: 89,
            failureDetails: [],
            fullName: 'Table grouping',
            numPassingAsserts: 0,
            status: 'passed',
            title: 'grouping'
          }]
        }],
        coverage: {
          'Table.tsx': {
            lines: {
              total: 51,
              covered: 50,
              skipped: 0,
              pct: 98.04
            },
            functions: {
              total: 10,
              covered: 7,
              skipped: 0,
              pct: 70
            },
            statements: {
              total: 56,
              covered: 55,
              skipped: 0,
              pct: 98.21
            },
            branches: {
              total: 49,
              covered: 40,
              skipped: 0,
              pct: 81.63
            }
          },
          'TableFilter.tsx': {
            lines: {
              total: 6,
              covered: 5,
              skipped: 0,
              pct: 83.33
            },
            functions: {
              total: 2,
              covered: 1,
              skipped: 0,
              pct: 50
            },
            statements: {
              total: 6,
              covered: 5,
              skipped: 0,
              pct: 83.33
            },
            branches: {
              total: 4,
              covered: 1,
              skipped: 0,
              pct: 25
            }
          },
          'TableGrouping.tsx': {
            lines: {
              total: 20,
              covered: 19,
              skipped: 0,
              pct: 95
            },
            functions: {
              total: 8,
              covered: 8,
              skipped: 0,
              pct: 100
            },
            statements: {
              total: 21,
              covered: 20,
              skipped: 0,
              pct: 95.24
            },
            branches: {
              total: 20,
              covered: 15,
              skipped: 0,
              pct: 75
            }
          },
          'TableRowSelection.tsx': {
            lines: {
              total: 8,
              covered: 8,
              skipped: 0,
              pct: 100
            },
            functions: {
              total: 5,
              covered: 5,
              skipped: 0,
              pct: 100
            },
            statements: {
              total: 10,
              covered: 10,
              skipped: 0,
              pct: 100
            },
            branches: {
              total: 0,
              covered: 0,
              skipped: 0,
              pct: 100
            }
          },
          'useTableLayout.ts': {
            lines: {
              total: 7,
              covered: 7,
              skipped: 0,
              pct: 100
            },
            functions: {
              total: 3,
              covered: 3,
              skipped: 0,
              pct: 100
            },
            statements: {
              total: 8,
              covered: 8,
              skipped: 0,
              pct: 100
            },
            branches: {
              total: 4,
              covered: 4,
              skipped: 0,
              pct: 100
            }
          },
          'TablePagination.tsx': {
            lines: {
              total: 17,
              covered: 9,
              skipped: 0,
              pct: 52.94
            },
            functions: {
              total: 10,
              covered: 3,
              skipped: 0,
              pct: 30
            },
            statements: {
              total: 18,
              covered: 10,
              skipped: 0,
              pct: 55.56
            },
            branches: {
              total: 24,
              covered: 8,
              skipped: 0,
              pct: 33.33
            }
          }
        }
      },
      info: {
        description: "\nMarkdown **descripton** for *component*.\n        ",
        displayName: 'Control',
        props: {
          name: {
            type: {
              name: 'string'
            },
            description: 'a name property'
          },
          age: {
            type: {
              name: 'number'
            },
            description: 'age is a number property'
          }
        }
      }
    }
  },
  docs: {
    Story: {
      date: new Date('2020-01-01').toISOString(),
      dateModified: new Date('2020-03-31').toISOString(),
      package: 'test-package',
      componentsLookup: {
        ArrowButton: 'ArrowButton',
        Button: 'Button',
        Control: 'Control'
      },
      author: 'atanasster',
      title: 'Story',
      data: {
        'plain--controls': {
          '1': {
            name: 'Cecelia Langosh',
            age: 16
          },
          '2': {
            name: 'Murl Green I',
            age: 26
          },
          '3': {
            name: 'Lela McClure',
            age: 24
          },
          '4': {
            name: 'Ms. Jean Barrows',
            age: 23
          },
          '5': {
            name: 'Tanya Sanford',
            age: 19
          }
        }
      },
      stories: ['id-of-story', 'id-of-button-story', 'blocks-core-story-plain--controls', 'id-of-single']
    },
    mdxStory: {
      title: 'MDX Story',
      componentsLookup: {},
      author: 'atanasster',
      MDXPage: function MDXPage() {
        return React.createElement(MDXContent, {
          components: {}
        });
      },
      stories: ['mdx-story']
    }
  },
  stories: {
    'id-of-story': {
      renderFn: function renderFn() {
        return React.createElement(Heading, null, "Components");
      },
      id: 'id-of-story',
      doc: 'Story',
      component: 'ArrowButton',
      description: 'description of story',
      loc: {
        end: {
          column: 34,
          line: 8
        },
        start: {
          column: 21,
          line: 8
        }
      },
      name: 'story',
      source: "() => 'hello'",
      subcomponents: {
        'My Button Tab': 'Button'
      },
      subtitle: 'story subtitle'
    },
    'id-of-single': {
      id: 'id-of-single',
      renderFn: function renderFn() {
        return React.createElement(Heading, null, "Components");
      },
      doc: 'Story',
      component: 'ArrowButton',
      loc: {
        end: {
          column: 34,
          line: 8
        },
        start: {
          column: 21,
          line: 8
        }
      },
      name: 'story',
      source: "() => 'hello'",
      subcomponents: {
        'My Button Tab': 'Button'
      },
      subtitle: 'story subtitle'
    },
    'id-of-button-story': {
      id: 'id-of-button-story',
      renderFn: function renderFn() {
        return React.createElement(Button, null, "test");
      },
      doc: 'Story',
      component: 'Button',
      loc: {
        end: {
          column: 34,
          line: 8
        },
        start: {
          column: 21,
          line: 8
        }
      },
      name: 'button',
      source: "() => 'hello'"
    },
    'blocks-core-story-plain--controls': {
      renderFn: function renderFn() {
        return React.createElement(Donut, {
          value: 1 / 2,
          "aria-label": "example donut graphic"
        });
      },
      id: 'blocks-core-story-plain--controls',
      rawId: 'plain--controls',
      doc: 'Story',
      name: 'controls',
      component: 'Control',
      controls: {
        name: {
          type: ControlTypes.TEXT,
          label: 'Name',
          value: 'Mark'
        },
        age: {
          type: ControlTypes.NUMBER,
          label: 'Age',
          value: 19
        }
      },
      plugins: {
        figma: [{
          url: 'https://www.figma.com/file/vgf0guEmC5IKtjHJKkRVSr/Button?node-id=0%3A1',
          title: 'figma design file'
        }],
        notes: [{
          text: "\n## Component *design notes*\n\n1. Be user-friendly\n2. Be a11y accessible\n3. **Go to 1**\n            "
        }],
        images: [{
          src: img,
          'aria-label': 'design resource image'
        }]
      },
      arguments: [{
        loc: {
          end: {
            column: 14,
            line: 0
          },
          start: {
            column: 1,
            line: 0
          }
        },
        name: undefined,
        value: [{
          loc: {
            end: {
              column: 7,
              line: 0
            },
            start: {
              column: 3,
              line: 0
            }
          },
          name: 'name',
          usage: [{
            loc: {
              end: {
                column: 32,
                line: 1
              },
              start: {
                column: 28,
                line: 1
              }
            }
          }],
          value: 'name'
        }, {
          loc: {
            end: {
              column: 12,
              line: 0
            },
            start: {
              column: 9,
              line: 0
            }
          },
          name: 'age',
          value: 'age',
          usage: [{
            loc: {
              end: {
                column: 49,
                line: 1
              },
              start: {
                column: 46,
                line: 1
              }
            }
          }]
        }]
      }],
      source: "({ name, age }) => (\n  <h2>{`Hello, my name is ${name}, and I am ${age} years old.`}</h2>\n);\n"
    },
    'id-no-component': {
      renderFn: function renderFn() {
        return React.createElement(Heading, null, "Components");
      },
      id: 'id-no-component',
      doc: 'Story',
      name: 'no component',
      source: "() => 'hello'"
    },
    'mdx-story': {
      renderFn: function renderFn() {
        return React.createElement(Heading, null, "mdx story");
      },
      id: 'mdx-story',
      doc: 'mdxStory',
      name: 'mdx story',
      source: "() => 'hello'"
    }
  }
});

var MockContext = function MockContext(_ref65) {
  var children = _ref65.children,
      _ref65$storyId = _ref65.storyId,
      storyId = _ref65$storyId === void 0 ? 'id-of-story' : _ref65$storyId;

  var _a;

  var docId = (_a = store.stories[storyId]) === null || _a === void 0 ? void 0 : _a.doc;
  return React.createElement(BlockContextProvider, {
    storyId: storyId,
    store: store,
    docId: docId
  }, children);
};

var makeDecorators = function makeDecorators() {
  var storyId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'id-of-story';
  var props = arguments.length > 1 ? arguments[1] : undefined;
  return [function (controls, context) {
    var renderFn = context.renderFn;
    var story = typeof renderFn === 'function' ? renderFn : controls;
    return React.createElement(MockContext, Object.assign({
      storyId: storyId
    }, props), story(controls, context));
  }];
};

var mockDecorators = makeDecorators();
export { BaseComponentCommits, BasePlayground, BaseStoryData, BaseTestsCoverage, BaseTestsResults, BlockContextProvider, CURRENT_STORY, CommitsPopover, ComponentCommits, ComponentContributors, ComponentJSX, ComponentSource, ComponentStats, ComponentsBlockContainer, ComponentsContainer, Container, Description, DocumentItem, EditPage, ExternalDependencies, InvalidType, LocalDependencies, LocalImport, MockContext, NAME$2 as NAME, PackageLink, PackageVersion, PageContainer, PageTypeTag, Pagination, Playground, PlaygroundContext, PropsTable as Props, PropsTable, Search, Stories, Story, StoryBlockContainer, StoryConfig, StoryData, StoryPlayground, StoryRender, StorySource, Subtitle, TagsList, TestsCoverage, TestsResults, ThemeProvider, Title, getStoryBlockTitle, getStoryTitle, makeDecorators, mockDecorators, repositoryActions, store, useCustomProps };